(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super()
      this.select = null
      this.buttonText = null
      this.button = null
    }

    connectedCallback() {
      // Wait for DOM to be ready
      this.select = this.querySelector('select')
      this.button = this.querySelector('.element-button')

      if (this.select && this.button) {
        this.init()
      }
    }

    init() {
      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-text') || this.button.querySelector('[data-button-text]')

      // Set initial text
      this.updateButtonText()

      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e))

      // Add keyboard handler for the select element
      this.select.addEventListener('keydown', (e) => this.handleKeydown(e))

      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText())

      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus())
      this.select.addEventListener('blur', () => this.handleBlur())
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault()
      e.stopPropagation()

      // Trigger the native select
      this.select.focus()
      this.select.click()
    }

    handleKeydown(e) {
      // Handle keyboard navigation for the select
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault()
          this.select.click()
          break
        case 'ArrowDown':
        case 'ArrowUp':
          // Let the native select handle arrow key navigation
          break
        default:
          // Let other keys pass through
          break
      }
    }

    updateButtonText() {
      if (!this.buttonText) return

      const selectedOption = this.select.options[this.select.selectedIndex]
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || 'Select an option'
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused')
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused')
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.button) {
        this.button.removeEventListener('click', (e) => this.handleButtonClick(e))
      }
      if (this.select) {
        this.select.removeEventListener('keydown', (e) => this.handleKeydown(e))
        this.select.removeEventListener('change', () => this.updateButtonText())
        this.select.removeEventListener('focus', () => this.handleFocus())
        this.select.removeEventListener('blur', () => this.handleBlur())
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.customer"] && !Shopify.designMode) return;
  try {
    class FormCustomer extends HTMLElement {
    static emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

    connectedCallback() {
      this.controller?.abort()
      const { signal } = (this.controller = new AbortController())

      const form = this.querySelector('form')
      const input = form?.querySelector('input[name="contact[email]"]')
      if (!input) return

      const validate = () => {
        const ok = FormCustomer.emailPattern.test(input.value.trim())
        input.setCustomValidity(ok ? '' : this.dataset.invalidMessage)
      }

      input.addEventListener('input', validate, { signal })
      form.addEventListener(
        'submit',
        (e) => {
          validate()
          if (!form.reportValidity()) e.preventDefault()
        },
        { signal, passive: false }
      )
    }

    disconnectedCallback() {
      this.controller?.abort()
    }
  }

  customElements.define('form-customer', FormCustomer)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    constructor() {
      super()
      this.form = this.querySelector('form')
      this.submitButton = this.findSubmitButton()
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
    }

    findSubmitButton() {
      // Look for submit button in the form
      const submitButton = this.form.querySelector('button[type="submit"], input[type="submit"]')
      return submitButton
    }

    disableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = true
        this.submitButton.classList.add('product-form__submit-button--pulsing')
      }
    }

    enableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = false
        this.submitButton.classList.remove('product-form__submit-button--pulsing')
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault()

      // Disable submit button and start pulsing
      this.disableSubmitButton()

      // Get cart state before form submission
      let cartBeforeSubmission
      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`)
        cartBeforeSubmission = await cartResponse.json()
      } catch (error) {
        console.error('Failed to get cart state before submission:', error)
        cartBeforeSubmission = null
      }

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }

      const formData = new FormData(this.form)

      // Dispatch event allowing subscribers to modify formData
      this.dispatchEvent(
        new CustomEvent('product-form:submit:before', {
          bubbles: true,
          detail: {
            form: formData
          },
          cancelable: true
        })
      )

      // Wait for the next tick to allow async event listeners to complete
      // This ensures all synchronous and microtask listeners have finished
      await new Promise((resolve) => {
        // Use queueMicrotask for better performance than setTimeout
        queueMicrotask(resolve)
      })

      config.body = formData

      // Dispatch event allowing subscribers to handle cart request themselves
      const cartRequestEvent = new CustomEvent('product-form:cart:request', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: formData,
          config: config,
          cartBefore: cartBeforeSubmission,
          resolve: (responseData) => this.resolveCartRequest(responseData),
          reject: (error) => this.rejectCartRequest(error)
        }
      })

      const cartRequestHandled = !this.dispatchEvent(cartRequestEvent)
      let responseData

      try {
        if (cartRequestHandled) {
          // Event was cancelled, meaning a subscriber handled the cart request
          // We need to wait for them to provide the response data
          responseData = await this.waitForCartResponse()
        } else {
          // No subscriber handled it, proceed with default behavior
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config)
          responseData = await response.json()

          if (!response.ok) {
            throw responseData
          }
        }

        // Get updated cart state after form submission
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`)
        const cartAfterSubmission = await cartResponse.json()

        this.dispatchEvent(
          new CustomEvent('product-form:submit:success', {
            bubbles: true,
            detail: {
              form: formData,
              response: responseData,
              cart: cartAfterSubmission
            }
          })
        )

        // Only fire cart:update if there's a change from this specific submission
        if (this.hasCartChanged(cartBeforeSubmission, cartAfterSubmission)) {
          this.dispatchEvent(
            new CustomEvent('product-form:cart:update', {
              bubbles: true,
              detail: {
                cart: cartAfterSubmission,
                form: formData,
                response: responseData
              }
            })
          )
        }

        // Navigate to cart unless prevented by another event handler
        const cartNavigationEvent = new CustomEvent('product-form:cart:navigate', {
          bubbles: true,
          cancelable: true,
          detail: {
            form: formData,
            response: responseData,
            cart: cartAfterSubmission
          }
        })

        const navigationPrevented = !this.dispatchEvent(cartNavigationEvent)

        if (!navigationPrevented) {
          window.location.href = `${window.Shopify.routes.root}cart`
        }
      } catch (error) {
        this.dispatchEvent(
          new CustomEvent('product-form:submit:error', {
            bubbles: true,
            detail: {
              form: formData,
              cart: cartBeforeSubmission,
              error: error
            }
          })
        )
      } finally {
        // Re-enable submit button and stop pulsing
        this.enableSubmitButton()
      }
    }

    /**
     * Waits for a subscriber to provide cart response data after handling the cart request
     * @returns {Promise<Object>} The cart response data
     */
    waitForCartResponse() {
      return new Promise((resolve, reject) => {
        // Store the resolver for this request
        this._cartRequestResolver = { resolve, reject }

        // Set a timeout to prevent hanging
        const timeout = setTimeout(() => {
          if (this._cartRequestResolver) {
            delete this._cartRequestResolver
            reject(new Error('Cart request timeout - no response received from subscriber'))
          }
        }, 30000) // 30 second timeout

        // Store timeout reference for cleanup
        this._cartRequestResolver.timeout = timeout
      })
    }

    /**
     * Resolves a pending cart request with response data
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Object} responseData - The cart response data
     */
    resolveCartRequest(responseData) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout)
        this._cartRequestResolver.resolve(responseData)
        delete this._cartRequestResolver
      }
    }

    /**
     * Rejects a pending cart request with an error
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Error} error - The error that occurred
     */
    rejectCartRequest(error) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout)
        this._cartRequestResolver.reject(error)
        delete this._cartRequestResolver
      }
    }

    hasCartChanged(cartBefore, cartAfter) {
      if (!cartBefore || !cartAfter) {
        return true // If we can't compare, assume there's a change
      }

      // Deep comparison using JSON.stringify for simplicity
      // This handles all nested changes automatically
      return JSON.stringify(cartBefore) !== JSON.stringify(cartAfter)
    }
  }

  customElements.define('product-form', ProductForm)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product.messages"] && !Shopify.designMode) return;
  try {
    class ProductFormMessages extends HTMLElement {
    constructor() {
      super()

      // Pull localized error message from data attributes
      this.formId = this.dataset.formId
      this.defaultErrorMessage = this.dataset.error
      this.defaultSuccessMessage = this.dataset.success

      // Create abort controller for event cleanup
      this.abortController = new AbortController()
    }

    connectedCallback() {
      // Cache the template content for better performance
      this.cacheTemplate()
      this.bindEvents()
    }

    disconnectedCallback() {
      // Clean up event listeners when component is removed
      this.abortController.abort()
    }

    cacheTemplate() {
      const template = this.querySelector('template')
      if (template) {
        this.template = template.innerHTML
        this.templateElement = template
      }
    }

    bindEvents() {
      const { signal } = this.abortController

      // Listen for form submission start to clear error messages
      document.addEventListener('product-form:submit:before', this.handleSubmitStart.bind(this), { signal })

      // Listen for form errors
      document.addEventListener('product-form:submit:error', this.handleError.bind(this), { signal })

      // Listen for form success
      document.addEventListener('product-form:submit:success', this.handleSuccess.bind(this), { signal })
    }

    handleSubmitStart(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return
      }

      this.clearMessages()
    }

    handleSuccess(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return
      }

      let message = this.defaultSuccessMessage

      const successMessageEvent = new CustomEvent('product-form:message:success', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      })

      // Dispatch the event and check if it was cancelled
      const eventCancelled = !this.dispatchEvent(successMessageEvent)

      if (eventCancelled) {
        return
      }

      this.showMessage(successMessageEvent.detail.message)
    }

    handleError(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return
      }

      const error = e.detail.error
      let message = this.defaultErrorMessage

      // Use server response message if available (already localized)
      if (error.description) {
        message = error.description
      } else if (error.message) {
        message = error.message
      }

      const errorMessageEvent = new CustomEvent('product-form:message:error', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      })

      const eventCancelled = !this.dispatchEvent(errorMessageEvent)

      if (eventCancelled) {
        return
      }

      this.showMessage(errorMessageEvent.detail.message)
    }

    showMessage(message) {
      // Clear existing error messages
      this.clearMessages()
      this.classList.remove('hide')

      // Use cached template content and replace <slot> with the error message
      if (this.template) {
        const messageContent = this.template.replace('<slot></slot>', message)

        // Insert the error message content
        this.innerHTML = messageContent
      }
    }

    clearMessages() {
      this.classList.add('hide')

      // Restore the original template structure using cached template
      if (this.templateElement) {
        this.innerHTML = this.templateElement.outerHTML
      }
    }
  }

  customElements.define('product-form-messages', ProductFormMessages)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["frucare-locator-geo"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.FruCareGeo) return;
  const fold = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  const rad = Math.PI / 180;
  const validPoint = point => Boolean(point && point.latitude !== null && point.longitude !== null && String(point.latitude).trim() !== '' && String(point.longitude).trim() !== '' && Number.isFinite(Number(point.latitude)) && Number.isFinite(Number(point.longitude)) && Math.abs(Number(point.latitude)) <= 85.051129 && Math.abs(Number(point.longitude)) <= 180);
  const distanceKm = (a, b) => {
    if (!validPoint(a) || !validPoint(b)) return Infinity;
    const dLat = (b.latitude - a.latitude) * rad;
    const dLon = (b.longitude - a.longitude) * rad;
    const h = Math.sin(dLat / 2) ** 2 + Math.cos(a.latitude * rad) * Math.cos(b.latitude * rad) * Math.sin(dLon / 2) ** 2;
    return 12742.0176 * Math.atan2(Math.sqrt(h), Math.sqrt(Math.max(0, 1 - h)));
  };
  const createIndex = data => (Array.isArray(data) ? data : data.records).map((row, index) => {
    const point = Array.isArray(row) ? {country: row[0], postalCode: row[1], name: row[2], latitude: row[3], longitude: row[4], aliases: row[5], region: row[6]} : {...row};
    const plainName = point.name.replace(/\s*\([^)]*\)/g, '').replace(point.country === 'NL' ? /\s+(?:L|NB|GLD|UT|ZH|NH|DR|GR|OV|FR|ZLD)$/ : /\u0000/g, '');
    return {...point, key: `${point.country}-${point.postalCode}-${index}`, names: [...new Set([point.name, plainName, ...(point.aliases || [])].map(fold))]};
  });
  const collapseLocations = (rows, postalOnly) => {
    if (postalOnly) {
      const areas = new Map();
      for (const row of rows) {
        const key = `${row.country}-${row.postalCode}`;
        if (!areas.has(key)) areas.set(key, []);
        areas.get(key).push(row);
      }
      return [...areas].map(([key, members]) => {
        const centres = [...new Map(members.map(row => [`${Number(row.latitude).toFixed(6)},${Number(row.longitude).toFixed(6)}`, row])).values()];
        const names = [...new Set(members.map(row => row.name))].sort((a, b) => a.localeCompare(b));
        const postalCode = members[0].postalCode;
        return {key, country: members[0].country, name: names.join(' / '), postalCode, postalCodes: [postalCode], latitude: centres.reduce((sum, row) => sum + Number(row.latitude), 0) / centres.length, longitude: centres.reduce((sum, row) => sum + Number(row.longitude), 0) / centres.length, label: `${postalCode} ${names.join(' / ')}`, inputLabel: postalCode, approximate: true};
      });
    }
    const groups = [];
    for (const row of rows) {
      const group = groups.find(item => item.names.some(name => row.names.includes(name)) && distanceKm(item, row) <= 8);
      if (group) {
        const count = group.members.length;
        group.latitude = (group.latitude * count + Number(row.latitude)) / (count + 1);
        group.longitude = (group.longitude * count + Number(row.longitude)) / (count + 1);
        group.members.push(row);
        group.names = [...new Set([...group.names, ...row.names])];
      } else groups.push({...row, latitude: Number(row.latitude), longitude: Number(row.longitude), members: [row]});
    }
    return groups.map(group => {
      const codes = [...new Set(group.members.map(row => row.postalCode))];
      const label = `${codes.length === 1 ? `${codes[0]} ` : ''}${group.name}`;
      return {key: group.key, country: group.country, name: group.name, postalCode: codes.length === 1 ? codes[0] : '', postalCodes: codes, latitude: group.latitude, longitude: group.longitude, label, approximate: true};
    });
  };
  const resolveLocation = ({query, country = 'BE', records = []}) => {
    const text = fold(query);
    if (!text) return {status: 'empty', candidates: []};
    const scoped = records.filter(row => row.country === country);
    const codeMatch = text.match(/(?:^|\s)(\d{4})(?:\s|$)/);
    const compactDutch = country === 'NL' && /^\d{4}\s?[a-z]{2}$/.test(text);
    const code = compactDutch ? text.slice(0, 4) : codeMatch?.[1];
    let name = compactDutch ? '' : text.replace(code || '\u0000', '').trim();
    if (country === 'NL' && code && /^[a-z]{2}\s/.test(name)) name = name.slice(3).trim();
    const available = code ? scoped.filter(row => row.postalCode === code) : scoped;
    const primary = name ? available.filter(row => fold(row.name) === name) : [];
    const exact = primary.length ? primary : name ? available.filter(row => row.names.includes(name)) : available;
    let matches = exact;
    if (!matches.length && name.length >= 2) {
      const words = name.split(' ');
      matches = available.filter(row => row.names.some(value => words.every(word => value.split(' ').some(part => part.startsWith(word)))));
    }
    if (!matches.length) return {status: 'not_found', candidates: []};
    const candidates = collapseLocations(matches, Boolean(code && !name)).sort((a, b) => a.label.localeCompare(b.label)).slice(0, 10);
    return candidates.length === 1 ? {status: 'resolved', location: candidates[0], candidates} : {status: 'ambiguous', candidates};
  };
  const project = (point, zoom) => {
    const sin = Math.sin(Math.max(-85.051129, Math.min(85.051129, Number(point.latitude))) * rad);
    const size = 256 * 2 ** zoom;
    return {x: (Number(point.longitude) + 180) / 360 * size, y: (0.5 - Math.log((1 + sin) / (1 - sin)) / (4 * Math.PI)) * size};
  };
  const unproject = (point, zoom) => {
    const size = 256 * 2 ** zoom;
    return {longitude: point.x / size * 360 - 180, latitude: Math.atan(Math.sinh(Math.PI * (1 - 2 * point.y / size))) / rad};
  };
  const fitView = (points, width, height) => {
    if (!points.length) return {center: {latitude: 50.85, longitude: 4.5}, zoom: 7};
    let zoom = 12;
    for (; zoom > 5; zoom--) {
      const pixels = points.map(point => project(point, zoom));
      if (Math.max(...pixels.map(p => p.x)) - Math.min(...pixels.map(p => p.x)) <= width - 100 && Math.max(...pixels.map(p => p.y)) - Math.min(...pixels.map(p => p.y)) <= height - 100) break;
    }
    const pixels = points.map(point => project(point, zoom));
    return {zoom, center: unproject({x: (Math.min(...pixels.map(p => p.x)) + Math.max(...pixels.map(p => p.x))) / 2, y: (Math.min(...pixels.map(p => p.y)) + Math.max(...pixels.map(p => p.y))) / 2}, zoom)};
  };
  const createMap = (container, {onSelect = () => {}, labels = {}, tileUrl = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png'} = {}) => {
    const signal = new AbortController();
    container.classList.add('fc-geo-map');
    container.setAttribute('role', 'region');
    container.setAttribute('aria-label', labels.mapLabel || labels.map || 'Map');
    container.tabIndex = 0;
    const tiles = document.createElement('div');
    const markers = document.createElement('div');
    tiles.className = 'fc-geo-map__tiles';
    markers.className = 'fc-geo-map__markers';
    const controls = document.createElement('div');
    controls.className = 'fc-geo-map__controls';
    const attribution = document.createElement('div');
    attribution.className = 'fc-geo-map__attribution';
    const credit = document.createElement('a');
    credit.href = 'https://www.openstreetmap.org/copyright';
    credit.target = '_blank';
    credit.rel = 'noopener';
    credit.textContent = '© OpenStreetMap contributors';
    const placesCredit = document.createElement('a');
    placesCredit.href = 'https://www.geonames.org/';
    placesCredit.target = '_blank';
    placesCredit.rel = 'noopener';
    placesCredit.textContent = 'GeoNames';
    attribution.append(credit, ' · ', placesCredit);
    const status = document.createElement('div');
    status.className = 'fc-geo-map__status';
    status.setAttribute('aria-live', 'polite');
    status.hidden = true;
    container.replaceChildren(tiles, markers, controls, status, attribution);
    let partners = [], origin = null, radiusKm = 20, center = {latitude: 50.85, longitude: 4.5}, zoom = 7, selected = null, visible = false, gesture = null, frame = 0, moved = false, suppressClickUntil = 0;
    const tileCache = new Map();
    const pinCache = new Map();
    const pointers = new Map();
    const circle = document.createElement('div');
    circle.className = 'fc-geo-map__radius';
    const dot = document.createElement('div');
    dot.className = 'fc-geo-map__origin';
    const bounds = () => ({width: Math.max(container.clientWidth, 240), height: Math.max(container.clientHeight, 240)});
    const paintTiles = (left, top, width, height) => {
      if (!visible) return;
      const tileZoom = Math.floor(zoom);
      const tileSize = 256 * 2 ** (zoom - tileZoom);
      const next = new Set();
      for (let x = Math.floor(left / tileSize); x <= Math.floor((left + width) / tileSize); x++) {
        for (let y = Math.floor(top / tileSize); y <= Math.floor((top + height) / tileSize); y++) {
          if (y < 0 || y >= 2 ** tileZoom) continue;
          const wrappedX = ((x % 2 ** tileZoom) + 2 ** tileZoom) % 2 ** tileZoom;
          const key = `${tileZoom}/${wrappedX}/${y}`;
          next.add(key);
          let tile = tileCache.get(key);
          if (!tile) {
            tile = document.createElement('img');
            tile.alt = '';
            tile.setAttribute('aria-hidden', 'true');
            tile.draggable = false;
            tile.referrerPolicy = 'strict-origin-when-cross-origin';
            tile.src = tileUrl.replace('{z}', tileZoom).replace('{x}', wrappedX).replace('{y}', y);
            tile.addEventListener('error', () => {
              status.textContent = labels.mapUnavailable || '';
              status.hidden = !status.textContent;
            }, {once: true});
            tileCache.set(key, tile);
          }
          tile.style.transform = `translate(${x * tileSize - left}px, ${y * tileSize - top}px) scale(${tileSize / 256})`;
          if (tile.parentNode !== tiles) tiles.append(tile);
        }
      }
      for (const [key, tile] of tileCache) {
        if (!next.has(key)) {
          tile.remove();
          if (tileCache.size > 60) tileCache.delete(key);
        }
      }
    };
    const paint = () => {
      const {width, height} = bounds();
      const c = project(center, zoom);
      const left = c.x - width / 2, top = c.y - height / 2;
      paintTiles(left, top, width, height);
      if (validPoint(origin)) {
        const p = project(origin, zoom);
        const diameter = radiusKm * 2000 / (156543.03392 * Math.cos(origin.latitude * rad) / 2 ** zoom);
        circle.style.cssText = `left:${p.x - left}px;top:${p.y - top}px;width:${diameter}px;height:${diameter}px`;
        dot.style.cssText = `left:${p.x - left}px;top:${p.y - top}px`;
        if (circle.parentNode !== markers) markers.append(circle, dot);
      } else { circle.remove(); dot.remove(); }
      const nextPins = new Set();
      partners.forEach((partner, index) => {
        const id = String(partner.id);
        nextPins.add(id);
        const p = project(partner, zoom);
        let button = pinCache.get(id);
        if (!button) {
          button = document.createElement('button');
          button.type = 'button';
          button.className = 'fc-geo-map__pin';
          button.dataset.partnerId = id;
          button.addEventListener('click', () => { selected = id; highlight(); onSelect(id); });
          pinCache.set(id, button);
        }
        button.setAttribute('aria-label', partner.name);
        button.setAttribute('aria-pressed', String(String(partner.id) === selected));
        button.title = partner.name;
        button.textContent = String(index + 1);
        button.style.cssText = `left:${p.x - left}px;top:${p.y - top}px`;
        if (button.parentNode !== markers) markers.append(button);
      });
      for (const [id, pin] of pinCache) if (!nextPins.has(id)) { pin.remove(); pinCache.delete(id); }
    };
    const schedulePaint = () => {
      if (!frame) frame = requestAnimationFrame(() => { frame = 0; paint(); });
    };
    const highlight = () => {
      markers.querySelectorAll('[data-partner-id]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.partnerId === selected)));
      const partner = partners.find(p => String(p.id) === selected);
      status.textContent = partner?.name || '';
      status.hidden = !partner;
    };
    const fit = () => {
      cancelGesture();
      const {width, height} = bounds();
      const points = [...partners];
      if (validPoint(origin)) {
        points.push(origin, {latitude: Number(origin.latitude) + radiusKm / 111.32, longitude: Number(origin.longitude)}, {latitude: Number(origin.latitude) - radiusKm / 111.32, longitude: Number(origin.longitude)});
      }
      ({center, zoom} = fitView(points, width, height));
      paint();
    };
    const button = (text, label, action) => {
      const node = document.createElement('button');
      node.type = 'button';
      node.textContent = text;
      node.setAttribute('aria-label', label);
      node.title = label;
      node.addEventListener('click', action, {signal: signal.signal});
      controls.append(node);
    };
    const clampZoom = value => Math.max(5, Math.min(17, value));
    const setCenter = point => {
      const size = 256 * 2 ** zoom;
      center = unproject({x: ((point.x % size) + size) % size, y: Math.max(0, Math.min(size, point.y))}, zoom);
    };
    const zoomAt = (nextZoom, point) => {
      const {width, height} = bounds();
      const current = project(center, zoom);
      const offset = point || {x: width / 2, y: height / 2};
      const anchor = unproject({x: current.x + offset.x - width / 2, y: current.y + offset.y - height / 2}, zoom);
      zoom = clampZoom(nextZoom);
      const scaled = project(anchor, zoom);
      setCenter({x: scaled.x - offset.x + width / 2, y: scaled.y - offset.y + height / 2});
      schedulePaint();
    };
    button('+', labels.zoomIn || '+', () => zoomAt(Math.floor(zoom + 0.001) + 1));
    button('−', labels.zoomOut || '−', () => zoomAt(Math.ceil(zoom - 0.001) - 1));
    button('↔', labels.showAll || labels.fit || '↔', fit);
    container.addEventListener('keydown', event => {
      if (event.target !== container) return;
      if (['+', '=', '-', '−'].includes(event.key)) {
        event.preventDefault();
        zoomAt(zoom + (['+', '='].includes(event.key) ? 1 : -1));
        return;
      }
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
      event.preventDefault();
      const point = project(center, zoom);
      point.x += event.key === 'ArrowLeft' ? -100 : event.key === 'ArrowRight' ? 100 : 0;
      point.y += event.key === 'ArrowUp' ? -100 : event.key === 'ArrowDown' ? 100 : 0;
      setCenter(point);
      paint();
    }, {signal: signal.signal});
    const localPoint = event => {
      const rect = container.getBoundingClientRect();
      return {x: event.clientX - rect.left, y: event.clientY - rect.top};
    };
    const snapshotGesture = () => {
      const points = [...pointers.values()].slice(0, 2);
      if (!points.length) { gesture = null; container.classList.remove('is-dragging'); return; }
      const midpoint = points.length === 2 ? {x: (points[0].x + points[1].x) / 2, y: (points[0].y + points[1].y) / 2} : points[0];
      const {width, height} = bounds();
      const c = project(center, zoom);
      gesture = {midpoint: {x: midpoint.x, y: midpoint.y}, zoom, center: c, distance: points.length === 2 ? Math.max(1, Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y)) : 0, anchor: unproject({x: c.x + midpoint.x - width / 2, y: c.y + midpoint.y - height / 2}, zoom)};
    };
    const releasePointer = pointer => {
      try { if (pointer.capture.hasPointerCapture(pointer.id)) pointer.capture.releasePointerCapture(pointer.id); } catch (_) {}
    };
    const cancelGesture = () => {
      const captured = [...pointers.values()];
      pointers.clear();
      gesture = null;
      moved = false;
      container.classList.remove('is-dragging');
      captured.forEach(releasePointer);
    };
    container.addEventListener('pointerdown', event => {
      if ((event.pointerType === 'mouse' && event.button !== 0) || event.target.closest('.fc-geo-map__controls,a')) return;
      if (!pointers.size) { moved = false; suppressClickUntil = 0; }
      const capture = event.target.closest('.fc-geo-map__pin') || container;
      pointers.set(event.pointerId, {...localPoint(event), id: event.pointerId, capture});
      try { capture.setPointerCapture(event.pointerId); } catch (_) {}
      if (capture === container) container.focus({preventScroll: true});
      if (pointers.size > 1) moved = true;
      snapshotGesture();
    }, {signal: signal.signal});
    container.addEventListener('pointermove', event => {
      const pointer = pointers.get(event.pointerId);
      if (!pointer || !gesture) return;
      Object.assign(pointer, localPoint(event));
      const points = [...pointers.values()].slice(0, 2);
      const midpoint = points.length === 2 ? {x: (points[0].x + points[1].x) / 2, y: (points[0].y + points[1].y) / 2} : points[0];
      const dx = midpoint.x - gesture.midpoint.x, dy = midpoint.y - gesture.midpoint.y;
      if (!moved && Math.hypot(dx, dy) < 4) return;
      moved = true;
      event.preventDefault();
      container.classList.add('is-dragging');
      if (points.length === 2) {
        const distance = Math.max(1, Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y));
        zoom = clampZoom(gesture.zoom + Math.log2(distance / gesture.distance));
        const anchor = project(gesture.anchor, zoom);
        const {width, height} = bounds();
        setCenter({x: anchor.x - midpoint.x + width / 2, y: anchor.y - midpoint.y + height / 2});
      } else setCenter({x: gesture.center.x - dx, y: gesture.center.y - dy});
      schedulePaint();
    }, {signal: signal.signal, passive: false});
    const endPointer = event => {
      const pointer = pointers.get(event.pointerId);
      if (!pointer) return;
      pointers.delete(event.pointerId);
      if (moved) suppressClickUntil = Date.now() + 450;
      releasePointer(pointer);
      snapshotGesture();
      if (!pointers.size) { moved = false; schedulePaint(); }
    };
    container.addEventListener('pointerup', endPointer, {signal: signal.signal});
    container.addEventListener('pointercancel', endPointer, {signal: signal.signal});
    container.addEventListener('lostpointercapture', endPointer, {signal: signal.signal});
    container.addEventListener('click', event => {
      if (event.detail !== 0 && Date.now() < suppressClickUntil) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, {signal: signal.signal, capture: true});
    container.addEventListener('wheel', event => {
      if (event.target.closest('.fc-geo-map__controls,a') || pointers.size) return;
      event.preventDefault();
      const delta = event.deltaY * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? bounds().height : 1);
      zoomAt(zoom - Math.max(-1, Math.min(1, delta / 240)), localPoint(event));
    }, {signal: signal.signal, passive: false});
    const resize = new ResizeObserver(() => { if (visible) schedulePaint(); });
    resize.observe(container);
    const intersection = new IntersectionObserver(entries => {
      visible = entries.some(entry => entry.isIntersecting);
      if (visible) paint();
    });
    intersection.observe(container);
    return {
      update(options) { partners = (options.partners || []).filter(validPoint); origin = options.origin || null; radiusKm = options.radiusKm || 20; selected = null; status.hidden = true; markers.replaceChildren(); fit(); },
      select(id) { selected = String(id); highlight(); },
      destroy() { signal.abort(); cancelGesture(); if (frame) cancelAnimationFrame(frame); intersection.disconnect(); resize.disconnect(); container.replaceChildren(); tileCache.clear(); pinCache.clear(); }
    };
  };
  window.FruCareGeo = {createIndex, resolveLocation, distanceKm, createMap, validPoint, project, unproject, fitView};
  window.dispatchEvent(new CustomEvent('frucare:geo-ready'));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["frucare-retailer-locator"] && !Shopify.designMode) return;
  try {
    (() => {
const fold = value => String(value ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/ß/g, 'ss').replace(/œ/g, 'oe').replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
const matchesText = (value, search) => fold(search).split(' ').filter(Boolean).every(word => fold(value).includes(word));
const productId = value => String(value ?? '').replace(/^gid:\/\/shopify\/Product\//, '');
const variantId = value => String(value ?? '').replace(/^gid:\/\/shopify\/ProductVariant\//, '');
const coordinates = point => point && Number.isFinite(Number(point.latitude)) && Number.isFinite(Number(point.longitude)) && point.latitude !== null && point.longitude !== null && point.latitude !== '' && point.longitude !== '' && Math.abs(Number(point.latitude)) <= 90 && Math.abs(Number(point.longitude)) <= 180;
function distanceKm(a, b) {
  if (!coordinates(a) || !coordinates(b)) return null;
  const r = Math.PI / 180;
  const dlat = (b.latitude - a.latitude) * r;
  const dlon = (b.longitude - a.longitude) * r;
  const h = Math.sin(dlat / 2) ** 2 + Math.cos(a.latitude * r) * Math.cos(b.latitude * r) * Math.sin(dlon / 2) ** 2;
  return 6371.0088 * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(Math.max(0, 1 - h)));
}
function prepareData(catalog, partners, offers, locale) {
  const products = new Map(catalog.map((item, index) => [productId(item.id), { ...item, id: productId(item.id), index, searchTerms: [item.title, ...(Array.isArray(item.aliases) ? item.aliases : [])].filter(Boolean).join(' ') }]));
  const collator = new Intl.Collator(locale || 'en', { sensitivity: 'base', numeric: true });
  const prepared = new Map(partners.map(partner => [String(partner.id), { ...partner, offers: new Map() }]));
  for (const offer of offers) {
    const partner = prepared.get(String(offer.stockistId));
    const id = productId(offer.productId);
    if (!partner || !products.has(id)) continue;
    if (!partner.offers.has(id)) partner.offers.set(id, new Map());
    if (offer.variantId) partner.offers.get(id).set(variantId(offer.variantId), offer.hasOnlyDefaultVariant ? '' : String(offer.variantTitle || ''));
  }
  return { products, partners: Array.from(prepared.values()).sort((a, b) => collator.compare(a.city || '', b.city || '') || collator.compare(a.name || '', b.name || '')) };
}
function addTranslatedNames(model, catalogs) {
  for (const catalog of catalogs) for (const item of catalog) {
    const product = model.products.get(productId(item.id));
    if (product && item.title) product.searchTerms += ' ' + item.title;
  }
}
function selectPartners(partners, selected, { country = '', origin = null, radiusKm = 20 } = {}) {
  const wanted = Array.from(selected, productId);
  const countryCode = String(country || '').trim().toUpperCase();
  const found = partners.filter(partner => (!countryCode || String(partner.countryCode || '').trim().toUpperCase() === countryCode) && wanted.every(id => partner.offers.has(id))).map(partner => ({ ...partner, distance: origin ? distanceKm(origin, partner) : null }));
  return origin ? found.filter(partner => partner.distance !== null && partner.distance <= radiusKm).sort((a, b) => a.distance - b.distance) : found;
}
const provinceOrder = ['BE-VWV', 'BE-VOV', 'BE-VAN', 'BE-VLI', 'BE-VBR', 'BE-BRU', 'BE-WHT', 'BE-WBR', 'BE-WNA', 'BE-WLG', 'BE-WLX', 'NL-DR', 'NL-FL', 'NL-FR', 'NL-GE', 'NL-GR', 'NL-LI', 'NL-NB', 'NL-NH', 'NL-OV', 'NL-UT', 'NL-ZE', 'NL-ZH'];
function countrySort(a, b) {
  const rank = code => code === 'BE' ? 0 : code === 'NL' ? 1 : code ? 2 : 3;
  return rank(a) - rank(b) || a.localeCompare(b, 'en');
}
function countryLabel(code, locale, labels = {}) {
  const key = code === 'BE' ? 'belgium' : code === 'NL' ? 'netherlands' : '';
  if (key && labels[key]) return labels[key];
  if (!code) return labels.other_locations || '';
  try { return new Intl.DisplayNames([locale || 'en'], { type: 'region' }).of(code) || code; }
  catch { return code; }
}
function resolveSearchLocation({ query, country = '', records = [], geo, locale, labels = {} }) {
  const countryCode = String(country || '').trim().toUpperCase();
  if (countryCode) return geo.resolveLocation({ query, country: countryCode, records });
  const countries = [...new Set(records.map(place => place.country).filter(Boolean))].sort(countrySort);
  const answers = countries.map(code => geo.resolveLocation({ query, country: code, records }));
  const candidates = answers.flatMap(answer => answer.status === 'resolved' ? [answer.location] : answer.candidates || []).map(place => ({
    ...place,
    label: place.label + ' · ' + countryLabel(place.country, locale, labels)
  }));
  if (!candidates.length) return { status: String(query || '').trim() ? 'not_found' : 'empty', candidates: [] };
  return candidates.length === 1 ? { status: 'resolved', location: candidates[0], candidates } : { status: 'ambiguous', candidates };
}
function partnerProvince(partner, provinceByPostalCode = {}) {
  const country = String(partner.countryCode || '').toUpperCase();
  const supplied = String(partner.provinceCode || '').toUpperCase();
  if (supplied.startsWith(country + '-') && provinceOrder.includes(supplied)) return supplied;
  const postalCode = String(partner.postalCode || '').trim().match(/^([0-9]{4})(?:\s*[a-z]{2})?$/i)?.[1];
  const province = provinceByPostalCode[country]?.[postalCode];
  if (typeof province === 'string') return province;
  const city = fold(partner.city);
  const candidates = (province?.candidates || []).filter(item => [item.name, ...(item.aliases || [])].some(name => fold(name) === city));
  const matches = [...new Set(candidates.map(item => item.provinceCode))];
  return matches.length === 1 ? matches[0] : '';
}
function groupPartners(partners, locale, provinceByPostalCode = {}, labels = {}) {
  const collator = new Intl.Collator(locale || 'en', { sensitivity: 'base', numeric: true });
  const groups = new Map();
  for (const partner of partners) {
    const code = partnerProvince(partner, provinceByPostalCode);
    const countryCode = String(partner.countryCode || '').trim().toUpperCase();
    const labelKey = code ? 'province_' + code.toLowerCase().replaceAll('-', '_') : 'other_locations';
    const countryLabelKey = countryCode === 'BE' ? 'belgium' : countryCode === 'NL' ? 'netherlands' : '';
    const areaCode = code.startsWith('BE-V') ? 'BE-VLG' : code === 'BE-BRU' ? 'BE-BRU' : code.startsWith('BE-W') ? 'BE-WAL' : '';
    const areaLabelKey = areaCode === 'BE-VLG' ? 'region_flanders' : areaCode === 'BE-BRU' ? 'region_brussels' : areaCode === 'BE-WAL' ? 'region_wallonia' : '';
    const key = [countryCode, code || 'other'].join(':');
    if (!groups.has(key)) groups.set(key, { key, code, labelKey, label: labels[labelKey] || code, countryCode, countryLabelKey, countryLabel: countryLabel(countryCode, locale, labels), areaCode, areaLabelKey, areaLabel: labels[areaLabelKey] || '', order: provinceOrder.includes(code) ? provinceOrder.indexOf(code) : provinceOrder.length, partners: [] });
    groups.get(key).partners.push(partner);
  }
  for (const group of groups.values()) group.partners.sort((a, b) => collator.compare(a.city || '', b.city || '') || collator.compare(a.name || '', b.name || ''));
  return Array.from(groups.values()).sort((a, b) => countrySort(a.countryCode, b.countryCode) || a.order - b.order || a.code.localeCompare(b.code, 'en'));
}
function addressLines(partner, countryName) {
  const address = String(partner.address || '').trim();
  const postalCode = String(partner.postalCode || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const marker = postalCode ? address.search(new RegExp('(?:,\\s*|\\n\\s*)' + postalCode + '(?:\\s|$)')) : -1;
  const street = marker >= 0 ? address.slice(0, marker).trim() : address.split(/\r?\n|,\s*/)[0];
  const town = [partner.postalCode, partner.city].filter(Boolean).join(' ');
  return [street, town, countryName || partner.countryCode].filter(Boolean).join('\n');
}
class FruCareRetailerLocator extends HTMLElement {
  connectedCallback() {
    if (this.initialized) {
      if (this.wasDisconnected) {
        this.wasDisconnected = false;
        this.geoPromise = this.loadGeo();
        this.load();
      }
      return;
    }
    this.initialized = true;
    this.labels = JSON.parse(this.querySelector('[data-locator-labels]').textContent);
    this.selected = new Set();
    this.radiusKm = 20;
    this.search = this.querySelector('[data-product-search]');
    this.countryInput = this.querySelector('[data-country]');
    this.countryCode = this.querySelector('[data-country-code]');
    this.locationInput = this.querySelector('[data-location-search]');
    this.locationStatus = this.querySelector('[data-location-status]');
    this.choices = this.querySelector('[data-product-choices]');
    this.results = this.querySelector('[data-results]');
    this.status = this.querySelector('[data-status]');
    this.retry = this.querySelector('[data-retry]');
    this.controls = this.querySelector('[data-controls]');
    this.syncInputControls();
    this.querySelector('[data-product-picker]').open = window.matchMedia('(min-width: 750px)').matches;
    this.addEventListener('input', event => {
      if (event.target === this.search) this.filterProducts();
      if (event.target === this.locationInput) {
        if (!this.locationInput.value.trim()) this.clearLocation();
        else this.syncInputControls();
      }
    });
    this.querySelector('[data-location-form]').addEventListener('submit', event => {
      event.preventDefault();
      this.searchLocation();
    });
    this.search.addEventListener('keydown', event => {
      if (event.key === 'Enter') { event.preventDefault(); this.submitProductSearch(); }
    });
    this.querySelector('[data-product-submit]').addEventListener('click', () => this.submitProductSearch());
    this.addEventListener('change', event => {
      if (event.target === this.countryInput) {
        this.countryCode.textContent = this.countryInput.value || this.t('all_countries_short');
        this.locationInput.value = '';
        this.clearLocation();
        return;
      }
      if (!event.target.matches('[data-product-checkbox]')) return;
      if (event.target.checked) this.selected.add(event.target.value);
      else this.selected.delete(event.target.value);
      this.renderSelection();
      this.renderResults();
    });
    this.addEventListener('click', event => {
      const remove = event.target.closest('[data-remove-product]');
      if (remove) {
        this.selected.delete(remove.dataset.removeProduct);
        this.syncCheckboxes();
        this.renderSelection();
        this.renderResults();
        this.focusProductSearch();
      }
      if (event.target.closest('[data-clear]')) {
        this.selected.clear();
        this.syncCheckboxes();
        this.renderSelection();
        this.renderResults();
        this.focusProductSearch();
      }
      if (event.target.closest('[data-clear-location]')) {
        this.locationInput.value = '';
        this.clearLocation();
        this.locationInput.focus();
      }
      if (event.target.closest('[data-clear-product-search]')) this.clearProductSearch();
      const anchor = event.target.closest('[data-locator-anchor]');
      if (anchor) {
        const target = document.getElementById(anchor.hash.slice(1));
        if (target) { event.preventDefault(); this.scrollToElement(target); }
      }
    });
    this.retry.addEventListener('click', () => this.load());
    this.geoPromise = this.loadGeo();
    this.load();
  }
  disconnectedCallback() {
    this.wasDisconnected = true;
    this.abort?.abort();
    this.geoAbort?.abort();
    this.mapObserver?.disconnect();
    this.map?.destroy();
    this.map = null;
  }
  t(key, values = {}) {
    let text = this.labels[key] || '';
    for (const [name, value] of Object.entries(values)) text = text.replaceAll('{' + name + '}', String(value));
    return text;
  }
  node(tag, className, content) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (content !== undefined && content !== null) node.textContent = content;
    return node;
  }
  safeLink(url, title, className = '') {
    if (!url) return null;
    try {
      const target = new URL(url, window.location.origin);
      if (!['http:', 'https:', 'tel:', 'mailto:'].includes(target.protocol)) return null;
      const link = this.node('a', className, title);
      link.href = target.href;
      if (target.origin !== window.location.origin && ['http:', 'https:'].includes(target.protocol)) {
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
      }
      return link;
    } catch { return null; }
  }
  scrollToElement(target) {
    target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  }
  async loadGeo() {
    try {
      const controller = this.geoAbort = new AbortController();
      this.geo = window.FruCareGeo || await new Promise((resolve, reject) => {
        const ready = () => { clearTimeout(timer); resolve(window.FruCareGeo); };
        const timer = setTimeout(() => { window.removeEventListener('frucare:geo-ready', ready); reject(new Error('Geodata unavailable')); }, 12000);
        window.addEventListener('frucare:geo-ready', ready, { once: true, signal: controller.signal });
        controller.signal.addEventListener('abort', () => { clearTimeout(timer); reject(new DOMException('Aborted', 'AbortError')); }, { once: true });
      });
      if (controller.signal.aborted) throw new DOMException('Aborted', 'AbortError');
      const dataUrl = new URL(this.dataset.geodataUrl, window.location.origin);
      if (dataUrl.origin !== window.location.origin && !dataUrl.hostname.endsWith('.shopify.com') && !dataUrl.hostname.endsWith('.myshopify.com')) throw new Error('Invalid data source');
      const response = await fetch(dataUrl.href, { signal: controller.signal });
      if (!response.ok) throw new Error('Geodata unavailable');
      const geodata = await response.json();
      this.geoRecords = this.geo.createIndex(geodata);
      this.provinceByPostalCode = geodata.provinceByPostalCode || {};
      if (this.model) this.renderResults();
      const element = this.querySelector('[data-locator-map]');
      this.mapObserver = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting) || this.map) return;
        this.map = this.geo.createMap(element, {
          labels: { zoomIn: this.t('zoom_in'), zoomOut: this.t('zoom_out'), showAll: this.t('reset_map'), mapLabel: this.t('map_label'), mapUnavailable: this.t('map_error') },
          onSelect: id => this.openPartner(id)
        });
        this.map.update({ partners: this.found || [], origin: this.origin, radiusKm: this.radiusKm });
        this.mapObserver.disconnect();
      }, { rootMargin: '160px' });
      this.mapObserver.observe(element);
      return true;
    } catch (error) {
      if (error.name !== 'AbortError') this.querySelector('[data-map-status]').textContent = this.t('map_error');
      return false;
    }
  }
  syncInputControls() {
    this.querySelector('[data-clear-location]').hidden = !this.locationInput.value.length;
    this.querySelector('[data-clear-product-search]').hidden = !this.search.value.length;
    if (this.countryCode) this.countryCode.textContent = this.countryInput.value || this.t('all_countries_short');
  }
  clearProductSearch() {
    this.search.value = '';
    this.filterProducts();
    this.search.focus({ preventScroll: true });
  }
  closeOtherPartners(card) {
    for (const other of this.results.querySelectorAll('details[open]')) {
      if (other !== card) other.open = false;
    }
  }
  clearLocation() {
    this.locationSearchVersion = (this.locationSearchVersion || 0) + 1;
    this.origin = null;
    this.locationError = false;
    this.locationStatus.textContent = '';
    this.querySelector('[data-location-candidates]').replaceChildren();
    this.syncInputControls();
    this.renderResults();
  }
  async searchLocation() {
    const query = this.locationInput.value.trim();
    if (!query) { this.clearLocation(); return; }
    const button = this.querySelector('[data-location-form] button[type="submit"]');
    const version = this.locationSearchVersion = (this.locationSearchVersion || 0) + 1;
    button.disabled = true;
    this.locationStatus.textContent = this.t('location_loading');
    const ready = await this.geoPromise;
    button.disabled = false;
    if (version !== this.locationSearchVersion) return;
    this.querySelector('[data-location-candidates]').replaceChildren();
    if (!ready) { this.locationStatus.textContent = this.t('geo_unavailable'); return; }
    const answer = resolveSearchLocation({ query, country: this.countryInput.value, records: this.geoRecords, geo: this.geo, locale: this.lang, labels: this.labels });
    if (answer.status === 'resolved') {
      this.applyLocation(answer.location);
      return;
    }
    this.origin = null;
    this.locationError = true;
    this.querySelector('[data-clear-location]').hidden = false;
    this.locationStatus.textContent = this.t(answer.status === 'ambiguous' ? 'location_ambiguous' : 'location_unknown');
    const candidates = document.createDocumentFragment();
    for (const place of answer.candidates || []) {
      const choice = this.node('button', '', place.label);
      choice.type = 'button';
      choice.addEventListener('click', () => this.applyLocation(place));
      candidates.append(choice);
    }
    this.querySelector('[data-location-candidates]').replaceChildren(candidates);
    this.renderResults();
  }
  applyLocation(place) {
    this.origin = place;
    this.locationError = false;
    this.locationInput.value = place.inputLabel || [place.postalCode, place.name].filter(Boolean).join(' ');
    this.locationStatus.textContent = this.t('location_selected', { location: place.label });
    this.querySelector('[data-clear-location]').hidden = false;
    this.querySelector('[data-location-candidates]').replaceChildren();
    this.renderResults();
  }
  async chunks(base, section, collectLocaleUrls = false) {
    const signal = this.abort.signal;
    const initial = new URL(base, window.location.origin);
    const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    initial.searchParams.set('section_id', section);
    if (preview) initial.searchParams.set('preview_theme_id', preview);
    const seen = new Set();
    const items = [];
    let current = initial;
    while (current) {
      if (current.origin !== window.location.origin || seen.has(current.href)) throw new Error('Invalid pagination');
      seen.add(current.href);
      const response = await fetch(current.href, { credentials: 'same-origin', headers: { Accept: 'text/html' }, signal });
      if (!response.ok) throw new Error('Data unavailable');
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const block = document.querySelector('[data-locator-chunk]');
      if (!block) throw new Error('Data missing');
      const data = JSON.parse(block.textContent);
      if (!Array.isArray(data.items)) throw new Error('Invalid data');
      items.push(...data.items);
      if (collectLocaleUrls && Array.isArray(data.localeUrls)) this.catalogLocaleUrls = data.localeUrls;
      if (!data.next) break;
      current = new URL(data.next, current);
      current.searchParams.set('section_id', section);
      if (preview) current.searchParams.set('preview_theme_id', preview);
    }
    return items;
  }
  async load() {
    this.abort?.abort();
    this.abort = new AbortController();
    const revision = this.loadRevision = (this.loadRevision || 0) + 1;
    this.controls.disabled = true;
    this.retry.hidden = true;
    this.status.textContent = this.t('loading');
    this.results.replaceChildren();
    this.querySelector('[data-result-count]').textContent = '';
    this.setAttribute('aria-busy', 'true');
    try {
      const [catalog, partners, offers] = await Promise.all([
        this.chunks(this.dataset.catalogUrl, 'frucare-locator-catalog', true),
        this.chunks(this.dataset.pageUrl, 'frucare-locator-stockists'),
        this.chunks(this.dataset.pageUrl, 'frucare-locator-offers')
      ]);
      if (revision !== this.loadRevision || !this.isConnected) return;
      this.model = prepareData(catalog, partners, offers, this.lang);
      this.selected = new Set(Array.from(this.selected).filter(id => this.model.products.has(id)));
      this.renderProducts();
      this.renderSelection();
      this.controls.disabled = false;
      this.status.textContent = '';
      this.renderResults();
      this.loadTranslations();
    } catch (error) {
      if (error.name === 'AbortError' || revision !== this.loadRevision) return;
      this.status.textContent = this.t('error');
      this.retry.hidden = false;
    } finally { if (revision === this.loadRevision) this.setAttribute('aria-busy', 'false'); }
  }
  async loadTranslations() {
    const model = this.model;
    const urls = [...new Set((this.catalogLocaleUrls || []).map(item => typeof item === 'string' ? item : item.url).filter(Boolean))];
    const translated = await Promise.allSettled(urls.map(url => this.chunks(url, 'frucare-locator-catalog')));
    if (!this.isConnected || model !== this.model) return;
    addTranslatedNames(this.model, translated.filter(result => result.status === 'fulfilled').map(result => result.value));
    this.filterProducts();
  }
  renderProducts() {
    const list = document.createDocumentFragment();
    for (const product of this.model.products.values()) {
      const label = this.node('label', 'fc-locator__product');
      label.dataset.productId = product.id;
      const checkbox = this.node('input');
      checkbox.type = 'checkbox';
      checkbox.name = 'frucare-product';
      checkbox.value = product.id;
      checkbox.checked = this.selected.has(product.id);
      checkbox.dataset.productCheckbox = '';
      label.append(checkbox);
      if (product.image) {
        const image = this.node('img');
        image.src = product.image;
        image.alt = '';
        image.width = 40;
        image.height = 40;
        image.loading = 'lazy';
        label.append(image);
      }
      label.append(this.node('span', '', product.title));
      list.append(label);
    }
    this.choices.replaceChildren(list);
    this.filterProducts();
  }
  filterProducts() {
    this.syncInputControls();
    let count = 0;
    for (const label of this.choices.children) {
      label.hidden = !matchesText(this.model.products.get(label.dataset.productId)?.searchTerms, this.search.value);
      if (!label.hidden) count++;
    }
    this.querySelector('[data-no-products]').hidden = count > 0;
  }
  submitProductSearch() {
    this.filterProducts();
    const choice = Array.from(this.choices.children).find(label => !label.hidden);
    choice?.querySelector('input')?.focus({ preventScroll: true });
  }
  focusProductSearch() {
    const picker = this.querySelector('[data-product-picker]');
    (picker.open ? this.search : picker.querySelector('summary')).focus({ preventScroll: true });
  }
  syncCheckboxes() {
    for (const checkbox of this.querySelectorAll('[data-product-checkbox]')) checkbox.checked = this.selected.has(checkbox.value);
  }
  renderSelection() {
    const fragment = document.createDocumentFragment();
    for (const id of this.selected) {
      const product = this.model.products.get(id);
      if (!product) continue;
      const button = this.node('button', 'fc-locator__chip');
      button.type = 'button';
      button.dataset.removeProduct = id;
      button.setAttribute('aria-label', this.t('remove') + ': ' + product.title);
      button.append(this.node('span', '', product.title));
      const cross = this.node('span', '', '×');
      cross.setAttribute('aria-hidden', 'true');
      button.append(cross);
      fragment.append(button);
    }
    this.querySelector('[data-selected]').replaceChildren(fragment);
    this.querySelector('[data-selection]').hidden = !this.selected.size;
    this.querySelector('[data-selected-count]').replaceChildren(
      this.node('span', 'fc-locator__selected-desktop', this.selected.size ? this.t('selected_count', { count: this.selected.size }) : ''),
      this.node('span', 'fc-locator__selected-mobile', this.selected.size ? ' (' + this.selected.size + ')' : '')
    );
  }
  renderResults() {
    if (!this.model) return;
    const found = this.locationError ? [] : selectPartners(this.model.partners, this.selected, { country: this.countryInput.value, origin: this.origin, radiusKm: this.radiusKm });
    this.found = found;
    const countKey = this.selected.size > 1 ? (found.length === 1 ? 'count_selection_one' : 'count_selection') : (found.length === 1 ? 'count_one' : 'count');
    this.querySelector('[data-result-count]').textContent = this.t(countKey, { count: found.length });
    const openId = this.results.querySelector('details[open]')?.dataset.partnerId;
    const fragment = document.createDocumentFragment();
    if (this.origin) {
      for (const partner of found) fragment.append(this.partnerCard(partner, openId === String(partner.id)));
    } else {
      let countrySection, areaSection, countryCode, areaCode;
      for (const region of groupPartners(found, this.lang, this.provinceByPostalCode, this.labels)) {
        if (region.countryCode !== countryCode) {
          countryCode = region.countryCode;
          areaCode = undefined;
          countrySection = this.node('section', 'fc-locator__country-group');
          countrySection.append(this.node('h2', 'fc-locator__country-title', region.countryLabel));
          fragment.append(countrySection);
        }
        if (region.areaCode !== areaCode) {
          areaCode = region.areaCode;
          areaSection = this.node('section', 'fc-locator__area');
          if (region.areaLabel) areaSection.append(this.node('h3', 'fc-locator__area-title', region.areaLabel));
          countrySection.append(areaSection);
        }
        const group = this.node('section', 'fc-locator__group');
        if (region.code !== 'BE-BRU') group.append(this.node(region.areaLabel ? 'h4' : 'h3', 'fc-locator__region', region.label));
        for (const partner of region.partners) group.append(this.partnerCard(partner, openId === String(partner.id)));
        areaSection.append(group);
      }
    }
    this.results.replaceChildren(fragment);
    this.querySelector('[data-empty]').hidden = found.length > 0 || this.locationError;
    this.map?.update({ partners: found, origin: this.origin, radiusKm: this.radiusKm });
  }
  openPartner(id) {
    const card = Array.from(this.results.querySelectorAll('[data-partner-id]')).find(item => item.dataset.partnerId === String(id));
    if (!card) return;
    this.closeOtherPartners(card);
    card.open = true;
    this.scrollToElement(card);
    card.querySelector('summary').focus({ preventScroll: true });
  }
  partnerCard(partner, opened) {
    const card = this.node('details', 'fc-locator__partner');
    card.dataset.partnerId = partner.id;
    card.name = this.id + '-retailers';
    card.open = opened;
    const summary = this.node('summary', 'fc-locator__partner-summary');
    const heading = this.node('span', 'fc-locator__partner-heading');
    heading.append(this.node('span', 'fc-locator__partner-name', partner.name));
    if (partner.customerAccess === 'professionals') heading.append(' ', this.node('span', 'fc-locator__badge', this.t('professional')));
    if (partner.customerAccess === 'public_wholesale') heading.append(' ', this.node('span', 'fc-locator__badge', this.t('public_wholesale')));
    const location = [partner.city];
    if (partner.distance !== null && partner.distance !== undefined) {
      const km = new Intl.NumberFormat(this.lang || 'en', { maximumFractionDigits: 1 }).format(partner.distance);
      location.push(this.t('distance', { distance: km }));
    }
    summary.append(heading, this.node('span', 'fc-locator__partner-subtitle', location.filter(Boolean).join(' · ')));
    const arrow = this.node('span', 'fc-locator__chevron');
    arrow.setAttribute('aria-hidden', 'true');
    summary.append(arrow);
    card.append(summary);
    card.addEventListener('toggle', () => {
      if (card.open) { this.closeOtherPartners(card); this.map?.select(partner.id); }
    });
    const content = this.node('div', 'fc-locator__partner-content');
    const contacts = this.node('div', 'fc-locator__contacts');
    const countries = new Intl.DisplayNames([this.lang || 'en'], { type: 'region' });
    contacts.append(this.node('address', '', addressLines(partner, countries.of(partner.countryCode || 'BE'))));
    const links = this.node('div', 'fc-locator__links');
    const phone = String(partner.phone || '').replace(/[^+\d]/g, '');
    const email = String(partner.email || '').trim();
    const contactLinks = [
      [phone ? 'tel:' + phone : '', partner.phone],
      [email && !/[\s?]/.test(email) ? 'mailto:' + email : '', email],
      [partner.website, this.t('website')],
      [partner.mapsUrl, this.t('directions')]
    ];
    for (const [href, label] of contactLinks) {
      const link = this.safeLink(href, label, 'fc-locator__link');
      if (link) links.append(link);
    }
    contacts.append(links);
    const note = typeof partner.publicNotes === 'object' && partner.publicNotes !== null ? partner.publicNotes[(this.lang || 'en').split('-')[0]] || partner.publicNotes.en : '';
    if (note) contacts.append(this.node('p', 'fc-locator__muted', note));
    if (partner.hours && (!Array.isArray(partner.hours) || partner.hours.length)) {
      contacts.append(this.node('h4', 'fc-locator__small-heading', this.t('hours')));
      const formatter = new Intl.DateTimeFormat(this.lang || 'en', { weekday: 'long', timeZone: 'UTC' });
      const hours = Array.isArray(partner.hours) ? partner.hours.filter(row => row.day >= 1 && row.day <= 7).map(row => {
        const day = formatter.format(new Date(Date.UTC(2024, 0, Number(row.day))));
        return day + ': ' + (row.closed ? this.t('closed') : [row.opens, row.closes].filter(Boolean).join(' - '));
      }).join('\n') : partner.hours;
      contacts.append(this.node('p', 'fc-locator__hours', hours));
      contacts.append(this.node('p', 'fc-locator__muted', this.t('hours_check')));
    }
    content.append(contacts);
    const products = this.node('div', 'fc-locator__stock');
    products.append(this.node('h4', 'fc-locator__small-heading', this.t('assortment')));
    const list = this.node('ul', 'fc-locator__stock-list');
    const ordered = Array.from(partner.offers.entries()).sort(([a], [b]) => this.model.products.get(a).index - this.model.products.get(b).index);
    for (const [id, variants] of ordered) {
      const product = this.model.products.get(id);
      const item = this.node('li', this.selected.has(id) ? 'is-selected' : '');
      const link = this.safeLink(product.url, product.title);
      item.append(link || this.node('span', '', product.title));
      const sizes = Array.from(new Set(Array.from(variants.values()).filter(Boolean)));
      for (const size of sizes) item.append(this.node('span', 'fc-locator__sizes', size));
      if (variants.size === 0) item.append(this.node('span', 'fc-locator__sizes', this.t('unknown_format')));
      list.append(item);
    }
    if (ordered.length) products.append(list);
    else products.append(this.node('p', 'fc-locator__muted', this.t('unknown')));
    content.append(products);
    card.append(content);
    return card;
  }
}
if (!customElements.get('frucare-retailer-locator')) customElements.define('frucare-retailer-locator', FruCareRetailerLocator);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["frucare.collection-pagination"] && !Shopify.designMode) return;
  try {
    class FruCareCollectionLoad extends HTMLElement {
    connectedCallback() {
      this.owner = this.closest('item-grid')
      this.grid = this.closest('.collection-grid')
      this.button = this.querySelector('[data-load-more]')
      this.fallback = this.querySelector('[data-load-fallback]')
      this.status = this.querySelector('[data-load-status]')
      if (!this.owner || !this.grid || !this.button || !this.status) return
      this.lifecycle = new AbortController()
      this.request = null
      this.loading = false
      this.suspended = false
      this.failed = false
      this.startLocation = window.location.pathname + window.location.search
      this.page = Number(this.dataset.page)
      this.button.hidden = !this.dataset.nextUrl
      this.button.addEventListener('click', () => this.load(true), { signal: this.lifecycle.signal })
      if (this.fallback) this.fallback.hidden = true
      const suspend = () => this.suspend()
      for (const eventName of ['ajaxCollection:render', 'price-range:change', 'sort:selected']) {
        document.addEventListener(eventName, suspend, { capture: true, signal: this.lifecycle.signal })
      }
      window.addEventListener('popstate', suspend, { signal: this.lifecycle.signal })
      window.addEventListener('pagehide', suspend, { signal: this.lifecycle.signal })
      window.addEventListener('pageshow', (event) => {
        if (!event.persisted) return
        this.suspended = false
        this.startLocation = window.location.pathname + window.location.search
        this.observe()
      }, { signal: this.lifecycle.signal })
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting) && !this.failed && !document.hidden) this.load(false)
        }, { rootMargin: '1000px 0px' })
        this.observe()
      }
    }

    disconnectedCallback() {
      this.suspend()
      this.lifecycle?.abort()
    }

    suspend() {
      this.suspended = true
      this.request?.abort()
      this.observer?.disconnect()
    }

    observe() {
      if (!this.dataset.nextUrl || this.suspended || !this.isConnected) return
      this.observer?.unobserve(this)
      this.observer?.observe(this)
    }

    isCurrent() {
      return this.isConnected && !this.suspended && !this.owner.isAnimating &&
        this.grid.isConnected && !this.grid.closest('.unload') &&
        this.startLocation === window.location.pathname + window.location.search
    }

    async load(manual) {
      if (this.loading || !this.dataset.nextUrl || !this.isCurrent()) return
      this.loading = true
      this.failed = false
      this.request = new AbortController()
      this.button.disabled = true
      this.status.classList.remove('visually-hidden')
      this.status.textContent = this.dataset.loadingLabel
      this.grid.setAttribute('aria-busy', 'true')
      this.observer?.unobserve(this)
      const timeout = window.setTimeout(() => this.request?.abort(), 15000)
      try {
        const url = new URL(this.dataset.nextUrl, window.location.href)
        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) throw new Error('Invalid collection URL')
        const expectedPage = this.page + 1
        if (Number(url.searchParams.get('page')) !== expectedPage) throw new Error('Invalid next page')
        url.searchParams.set('section_id', this.dataset.sectionId)
        const previewId = new URLSearchParams(window.location.search).get('preview_theme_id')
        if (previewId) url.searchParams.set('preview_theme_id', previewId)
        const response = await fetch(url, { signal: this.request.signal, credentials: 'same-origin', headers: { Accept: 'text/html' } })
        if (!response.ok) throw new Error('Collection request failed')
        const html = await response.text()
        if (!this.isCurrent()) return
        const parsed = new DOMParser().parseFromString(html, 'text/html')
        const nextControl = Array.from(parsed.querySelectorAll('frucare-collection-load')).find((element) => element.dataset.sectionId === this.dataset.sectionId)
        const nextGrid = nextControl?.closest('.collection-grid')
        if (!nextGrid || Number(nextControl.dataset.page) !== expectedPage) throw new Error('Incomplete collection response')
        const knownProducts = new Set(Array.from(this.grid.querySelectorAll('[data-product-id]'), (element) => element.dataset.productId))
        const cards = Array.from(nextGrid.children).filter((element) => {
          if (!element.matches('.grid-product')) return false
          const productId = element.querySelector('[data-product-id]')?.dataset.productId
          if (!productId || knownProducts.has(productId)) return false
          knownProducts.add(productId)
          return true
        })
        if (!cards.length) throw new Error('No new products')
        const fragment = document.createDocumentFragment()
        cards.forEach((card) => fragment.append(card))
        this.grid.insertBefore(fragment, this)
        this.page = expectedPage
        this.dataset.page = String(expectedPage)
        this.dataset.nextUrl = nextControl.dataset.nextUrl || ''
        if (this.fallback && this.dataset.nextUrl) this.fallback.href = this.dataset.nextUrl
        if (this.fallback) this.fallback.hidden = true
        this.button.hidden = !this.dataset.nextUrl
        this.status.textContent = manual || !this.dataset.nextUrl ? this.dataset.loadedLabel.replace('__COUNT__', String(cards.length)) : ''
        this.status.classList.add('visually-hidden')
        this.owner.updateProductImageSizes?.(this.grid.dataset.view)
        this.dispatchEvent(new CustomEvent('frucare:collection-appended', { bubbles: true, detail: { count: cards.length, page: this.page } }))
        if (manual) {
          const firstLink = cards[0].querySelector('.grid-item__overlay-link')
          firstLink?.focus({ preventScroll: true })
        }
      } catch (error) {
        if (!this.isCurrent()) return
        this.failed = true
        this.status.textContent = this.dataset.errorLabel
        if (this.fallback) this.fallback.hidden = false
      } finally {
        window.clearTimeout(timeout)
        this.loading = false
        this.request = null
        this.button.disabled = false
        this.grid.removeAttribute('aria-busy')
        if (!this.failed) this.observe()
      }
    }
  }
  if (!customElements.get('frucare-collection-load')) customElements.define('frucare-collection-load', FruCareCollectionLoad)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["frucare.cookie-settings"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.FruCareCookieSettings) return;
  const selector = '[data-frucare-cookie-settings]';
  const bannerUrl = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
  let featureLoad;
  let bannerLoad;
  let opening;

  function privacy() {
    const api = window.Shopify && window.Shopify.customerPrivacy;
    return api && typeof api.currentVisitorConsent === 'function' ? api : null;
  }

  function allOptionalGranted() {
    try {
      const api = privacy();
      const consent = api && api.currentVisitorConsent();
      return !!consent && ['analytics', 'marketing', 'preferences'].every(key => consent[key] === 'yes');
    } catch (_) {
      return false;
    }
  }

  function refresh() {
    const granted = allOptionalGranted();
    document.querySelectorAll(selector).forEach(control => {
      control.hidden = control.dataset.cookiePlacement === 'shipping' && granted;
    });
  }

  function loadPrivacy() {
    if (privacy()) return Promise.resolve();
    if (featureLoad) return featureLoad;
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return Promise.resolve();
    featureLoad = new Promise(resolve => {
      let completed = false;
      let timer;
      const finish = () => {
        if (completed) return;
        completed = true;
        clearTimeout(timer);
        refresh();
        resolve();
      };
      timer = setTimeout(finish, 5000);
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], finish);
      } catch (_) {
        finish();
      }
    });
    return featureLoad;
  }

  function banner() {
    return window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function'
      ? window.privacyBanner : null;
  }

  function loadBanner() {
    if (banner()) return Promise.resolve(banner());
    if (bannerLoad) return bannerLoad;
    bannerLoad = new Promise((resolve, reject) => {
      let completed = false;
      let timer;
      const existing = document.querySelector('script[src^="' + bannerUrl + '"]');
      const script = existing || document.createElement('script');
      const finish = () => {
        if (completed) return;
        completed = true;
        clearTimeout(timer);
        script.removeEventListener('load', finish);
        script.removeEventListener('error', finish);
        const api = banner();
        if (api) resolve(api);
        else reject(new Error('Cookie preferences unavailable'));
      };
      script.addEventListener('load', finish);
      script.addEventListener('error', finish);
      timer = setTimeout(finish, 5000);
      if (!existing) {
        script.src = bannerUrl;
        script.async = true;
        document.head.appendChild(script);
      }
    }).catch(error => {
      bannerLoad = null;
      throw error;
    });
    return bannerLoad;
  }

  function open(control) {
    if (opening) return opening;
    document.querySelectorAll('[data-frucare-cookie-error]').forEach(node => { node.hidden = true; });
    document.querySelectorAll(selector).forEach(node => node.setAttribute('aria-busy', 'true'));
    opening = loadBanner()
      .then(api => api.showPreferences())
      .then(() => waitForDialog())
      .then(() => refresh())
      .catch(() => {
        const error = control.nextElementSibling;
        if (error && error.matches('[data-frucare-cookie-error]')) error.hidden = false;
      })
      .finally(() => {
        opening = null;
        document.querySelectorAll(selector).forEach(node => node.removeAttribute('aria-busy'));
      });
    return opening;
  }

  function waitForDialog() {
    return new Promise((resolve, reject) => {
      let observer;
      let timer;
      const visible = () => {
        const dialog = document.getElementById('shopify-pc__prefs__dialog');
        return dialog && !dialog.hidden && dialog.getAttribute('aria-hidden') !== 'true' && dialog.getClientRects().length > 0;
      };
      const check = () => {
        if (!visible()) return false;
        if (observer) observer.disconnect();
        clearTimeout(timer);
        resolve();
        return true;
      };
      if (check()) return;
      observer = new MutationObserver(check);
      observer.observe(document.body, { childList: true, subtree: true, attributes: true });
      timer = setTimeout(() => {
        observer.disconnect();
        reject(new Error('Cookie preferences did not open'));
      }, 5000);
    });
  }

  document.addEventListener('click', event => {
    const control = event.target.closest && event.target.closest(selector);
    if (!control || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open(control);
  }, true);
  document.addEventListener('visitorConsentCollected', () => {
    refresh();
    setTimeout(refresh, 0);
  });
  document.addEventListener('shopifyCustomerPrivacyApiLoaded', refresh);
  document.addEventListener('consentTrackingApiLoaded', refresh);
  document.addEventListener('shopify:section:load', refresh);
  window.addEventListener('pageshow', () => { loadPrivacy(); refresh(); });
  window.addEventListener('focus', refresh);
  window.FruCareCookieSettings = { refresh };
  loadPrivacy();
  refresh();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["frucare.gifts-cart"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('frucare-gifts-cart')) return
    const clients = new Set()
    let snapshot = null
    const valid = (state) => state && state.config && Number.isInteger(state.item_count) && state.item_count >= 0 && (state.amount === null || (Number.isInteger(state.amount) && state.amount >= 0))
    const receive = (state) => {
      if (!valid(state)) {
        snapshot = null
        clients.forEach((client) => {
          client.hidden = true
          const timing = client.closest('form')?.querySelector('[data-frucare-gift-timing]')
          if (timing) { timing.dataset.allowed = 'false'; timing.dataset.unlocked = 'false'; timing.hidden = true }
        })
        return
      }
      snapshot = state
      clients.forEach((client) => client.render(snapshot))
    }
    document.addEventListener('frucare:gifts-state', (event) => receive(event.detail))
    class FruCareGiftsCart extends HTMLElement {
      connectedCallback() {
        try {
          this.labels = JSON.parse(this.querySelector('[data-frucare-gifts-labels]').textContent)
          this.initialState = JSON.parse(this.querySelector('[data-frucare-gifts-state]').textContent)
        } catch { this.hidden = true; return }
        this.message = this.querySelector('[data-gift-message]')
        this.tiers = [...this.querySelectorAll('[data-gift-tier]')]
        clients.add(this)
        if (!snapshot) receive(this.initialState)
        else this.render(snapshot)
      }
      disconnectedCallback() { clients.delete(this) }
      render(state) {
        if (!valid(state)) { this.hidden = true; return }
        const config = state.config
        const visible = state.item_count > 0 && ['preview', 'active'].includes(config.mode) && config.customer_eligible === true && config.locale_supported === true
        this.hidden = !visible
        const timing = this.closest('form')?.querySelector('[data-frucare-gift-timing]')
        if (timing) timing.dataset.allowed = String(visible)
        if (!visible) {
          if (timing) { timing.dataset.unlocked = 'false'; timing.hidden = true }
          return
        }
        const known = Number.isInteger(state.amount) && state.currency === 'EUR'
        let money
        try { money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: 'EUR'}) }
        catch { money = new Intl.NumberFormat('en', {style: 'currency', currency: 'EUR'}) }
        this.tiers.forEach((tier) => {
          const threshold = config[tier.dataset.giftTier + '_threshold']
          const validThreshold = Number.isInteger(threshold) && threshold > 0
          const unlocked = validThreshold && known && state.amount >= threshold
          tier.hidden = !validThreshold
          tier.dataset.unlocked = String(unlocked)
          if (!validThreshold) return
          const remaining = known ? Math.max(0, threshold - state.amount) : threshold
          const amount = money.formatToParts(remaining / 100).filter((part) =>
            !['currency', 'literal'].includes(part.type) && !(remaining % 100 === 0 && ['decimal', 'fraction'].includes(part.type))
          ).map((part) => part.value).join('')
          const label = known && this.labels.remaining ? this.labels.remaining : this.labels.threshold
          const status = tier.querySelector('[data-gift-threshold]')
          if (unlocked && this.labels.unlocked) {
            const check = document.createElement('span')
            check.className = 'frucare-gifts-cart__check'
            check.setAttribute('aria-hidden', 'true')
            check.textContent = '✓'
            status.replaceChildren(check, document.createTextNode(' ' + this.labels.unlocked))
          } else status.textContent = label.replace('[amount]', '€\u00a0' + amount)
          const progress = tier.querySelector('[data-gift-progress]')
          if (progress) {
            progress.hidden = !known
            progress.value = known ? Math.min(100, state.amount * 100 / threshold) : 0
          }
        })
        if (this.dataset.compact === 'true') this.hidden = !this.tiers.some((tier) => !tier.hidden)
        if (timing) {
          timing.dataset.unlocked = String(this.tiers.some((tier) => tier.dataset.unlocked === 'true'))
          timing.hidden = timing.dataset.unlocked !== 'true' && timing.dataset.chosen !== 'true'
        }
        this.message.textContent = known ? '' : this.labels.unknown
      }
    }
    customElements.define('frucare-gifts-cart', FruCareGiftsCart)
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["frucare.reward-cart"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('frucare-reward-cart')) return
    const attribute = 'frucare_reward_request', clients = new Set()
    let catalog = null, choice = null, cartItemCount = null, tail = Promise.resolve(), writing = 0, readQueued = false, failed = false, retryCommand = null, initialized = false, cartConfirmed = false
    const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
    const parse = (raw) => {
      try {
        const value = typeof raw === 'string' ? JSON.parse(raw) : raw
        return value?.v === 1 && Object.keys(value).sort().join(',') === 'requestId,v,variantId' && typeof value.requestId === 'string' && uuid.test(value.requestId) && typeof value.variantId === 'string' && Object.hasOwn(catalog || {}, value.variantId) ? value : null
      } catch { return null }
    }
    const same = (a, b) => a === null && b === null || a?.requestId === b?.requestId && a?.variantId === b?.variantId
    const render = () => clients.forEach((client) => client.render())
    const root = () => { const value = clients.values().next().value?.dataset.root || '/'; return value.endsWith('/') ? value : `${value}/` }
    const readChoice = (cart) => {
      if (!cart || typeof cart.token !== 'string' || !cart.token || !Array.isArray(cart.items) || !Number.isSafeInteger(cart.item_count) || cart.item_count < 0 || !Number.isSafeInteger(cart.total_price) || !cart.attributes || typeof cart.attributes !== 'object') throw new Error('CART_UNAVAILABLE')
      cartItemCount = cart.item_count
      const raw = cart.attributes[attribute]
      return parse(raw)
    }
    const acceptsChoose = (command, cart) => command.before && command.before.token === cart.token && (same(readChoice(cart), command.value) || command.before.request === (cart.attributes[attribute] ?? ''))
    const request = async (body) => {
      const controller = new AbortController(), timeout = setTimeout(() => controller.abort(), 8000)
      try {
        const response = await fetch(`${root()}cart${body ? '/update' : ''}.js`, {method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', redirect: 'error', signal: controller.signal,
          headers: body ? {'Accept': 'application/json', 'Content-Type': 'application/json'} : {'Accept': 'application/json'}, body: body ? JSON.stringify(body) : undefined})
        if (!response.ok) throw new Error('CART_UNAVAILABLE')
        const cart = await response.json(); readChoice(cart); return cart
      } finally { clearTimeout(timeout) }
    }
    const queue = (command = null) => {
      if (command) { writing++; failed = false; render() }
      const operation = tail.then(async () => {
        cartConfirmed = false
        render()
        try {
          const before = await request(); choice = readChoice(before); cartConfirmed = true
          if (!command) {
            let changed = false
            if (retryCommand?.type === 'choose' && !acceptsChoose(retryCommand, before)) { retryCommand = null; changed = true }
            else if (retryCommand && same(choice, retryCommand.type === 'choose' ? retryCommand.value : null)) retryCommand = null
            failed = changed || Boolean(retryCommand); return
          }
          const target = command.type === 'choose' ? command.value : null
          if (command.type === 'choose') {
            if (!command.attempted) command.before = {token: before.token, request: before.attributes[attribute] ?? ''}
            if (!acceptsChoose(command, before)) throw new Error('REWARD_CHANGED')
          }
          if (command.type === 'remove' && choice && !same(choice, command.expected)) throw new Error('REWARD_CHANGED')
          if (!same(choice, target)) {
            let writeError = null
            try { await request({attributes: {[attribute]: target ? JSON.stringify(target) : ''}}) } catch (error) { writeError = error }
            const after = await request(); choice = readChoice(after); cartConfirmed = true
            if (command.type === 'choose' && !acceptsChoose(command, after)) throw new Error('REWARD_CHANGED')
            if (!same(choice, target)) throw writeError || new Error('REWARD_NOT_CONFIRMED')
            document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: after, frucareRewardChoice: true}}))
          }
          retryCommand = null; failed = false
        } catch (error) {
          cartConfirmed = false
          failed = true
          if (command) retryCommand = error.message === 'REWARD_CHANGED' ? null : command
        } finally { if (command) { command.attempted = true; writing-- } render() }
      })
      tail = operation.catch(() => {})
      return operation
    }
    const refresh = () => {
      if (readQueued || !clients.size) return tail
      readQueued = true
      const balances = [...clients].map(client => client.refreshBalance())
      return Promise.all([queue(), ...balances]).finally(() => { readQueued = false })
    }
    const takeIntent = () => {
      const url = new URL(location.href), fragment = new URLSearchParams(url.hash.slice(1))
      const variants = fragment.getAll('frucare_reward'), ids = fragment.getAll('frucare_reward_request')
      if (!variants.length && !ids.length) return false
      url.hash = ''
      history.replaceState(history.state, '', url.href)
      const value = parse({v: 1, requestId: ids[0], variantId: variants[0]})
      const authenticated = clients.values().next().value?.dataset.authenticated === 'true'
      if (variants.length !== 1 || ids.length !== 1 || [...fragment.keys()].some((key) => !['frucare_reward', 'frucare_reward_request'].includes(key)) || !value || !authenticated) { failed = true; render(); return true }
      void queue({type: 'choose', value}); return true
    }
    document.addEventListener('cart:updated', (event) => { if (!event.detail?.frucareRewardChoice) void refresh() })
    document.addEventListener('cart:open', refresh)
    window.addEventListener('pageshow', () => { if (!takeIntent()) void refresh() })
    window.addEventListener('online', refresh)
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') void refresh() })
    document.addEventListener('submit', (event) => {
      if (!writing || !event.target.matches('form[data-location="page"], form[data-location="header"]')) return
      event.preventDefault(); render()
    }, true)
    class FruCareRewardCart extends HTMLElement {
      connectedCallback() {
        this.config = JSON.parse(this.querySelector('[data-reward-config]').textContent)
        this.balanceUnits = this.config.bookedUnits
        if (!clients.size) cartItemCount = Number.isSafeInteger(this.config.itemCount) && this.config.itemCount >= 0 ? this.config.itemCount : null
        if (!catalog) { catalog = this.config.catalog; choice = parse(this.config.initial) }
        this.controller?.abort(); this.controller = new AbortController()
        const options = {signal: this.controller.signal}
        this.querySelector('[data-reward-remove]').addEventListener('click', () => { if (this.displayedChoice && !writing) void queue({type: 'remove', expected: this.displayedChoice}) }, options)
        this.querySelector('[data-reward-retry]').addEventListener('click', () => { if (!writing) void (retryCommand ? queue(retryCommand) : refresh()) }, options)
        const reconnect = initialized && !clients.size
        clients.add(this); this.render()
        if (!initialized) { initialized = true; if (!takeIntent()) void refresh() }
        else if (reconnect) void refresh()
      }
      disconnectedCallback() { this.controller?.abort(); this.balanceController?.abort(); clients.delete(this) }
      async refreshBalance() {
        if (!this.dataset.balanceSection) return
        this.balanceUnits = null; this.render()
        const generation = this.balanceGeneration = (this.balanceGeneration || 0) + 1
        this.balanceController?.abort()
        const controller = new AbortController(), timeout = setTimeout(() => controller.abort(), 8000)
        this.balanceController = controller
        try {
          const url = new URL(location.href); url.hash = ''; url.searchParams.delete('sections'); url.searchParams.set('section_id', this.dataset.balanceSection)
          const response = await fetch(url.href, {method: 'GET', credentials: 'same-origin', cache: 'no-store', redirect: 'error', signal: controller.signal, headers: {'Accept': 'text/html'}})
          if (!response.ok) throw new Error('BALANCE_UNAVAILABLE')
          const html = await response.text()
          if (typeof html !== 'string') throw new Error('BALANCE_UNAVAILABLE')
          const document = new DOMParser().parseFromString(html, 'text/html')
          const source = [...document.querySelectorAll('frucare-reward-cart[data-balance-section]')].find(element => element.dataset.balanceSection === this.dataset.balanceSection)
          if (!this.isConnected || source?.dataset.authenticated !== 'true' || !this.dataset.balanceOwner || source.dataset.balanceOwner !== this.dataset.balanceOwner) throw new Error('BALANCE_UNAVAILABLE')
          const value = JSON.parse(source.querySelector('[data-reward-config]').textContent).bookedUnits
          if (!Number.isSafeInteger(value) || value < 0 || value % 100 !== 0) throw new Error('BALANCE_UNAVAILABLE')
          if (generation === this.balanceGeneration) this.balanceUnits = value
        } catch { if (generation === this.balanceGeneration) this.balanceUnits = null }
        finally { clearTimeout(timeout); if (this.isConnected) this.render() }
      }
      render() {
        const emptyCartOnly = this.dataset.emptyCartOnly === 'true'
        const confirmedEmptyChoice = cartItemCount === 0 && choice && cartConfirmed && !failed && !writing && this.dataset.authenticated === 'true'
        const cartHidden = emptyCartOnly ? !confirmedEmptyChoice : this.classList.contains('frucare-reward-cart--compact') && (!Number.isSafeInteger(cartItemCount) || cartItemCount === 0)
        this.hidden = cartHidden
        const summary = this.closest('[data-frucare-gift-summary]')
        if (summary) summary.hidden = cartHidden
        this.displayedChoice = choice
        this.querySelector('[data-reward-selection]').hidden = !choice
        this.querySelector('[data-reward-account-prompt]').hidden = Boolean(choice) && this.dataset.authenticated === 'true'
        const image = this.querySelector('[data-reward-image]')
        if (image) image.hidden = !choice || !catalog[choice.variantId].image
        if (choice) {
          this.querySelector('[data-reward-title]').textContent = catalog[choice.variantId].title
          this.querySelector('[data-reward-cost]').textContent = catalog[choice.variantId].points
          if (image && catalog[choice.variantId].image) {
            image.src = catalog[choice.variantId].image
            image.alt = catalog[choice.variantId].title
          }
        } else if (image) {
          image.removeAttribute('src')
          image.alt = ''
        }
        this.querySelector('[data-reward-remove]').disabled = writing > 0
        this.querySelector('[data-reward-retry]').hidden = !failed || writing > 0
        this.querySelector('[data-reward-status]').textContent = writing ? this.config.labels.saving : failed ? this.config.labels.error : ''
        const timing = this.closest('form')?.querySelector('[data-frucare-gift-timing]')
        if (timing) {
          timing.dataset.chosen = String(Boolean(choice && cartConfirmed && !failed && !writing))
          timing.hidden = cartHidden || timing.dataset.allowed === 'false' || (timing.dataset.unlocked !== 'true' && timing.dataset.chosen !== 'true')
        }
        const balance = this.querySelector('[data-reward-balance]')
        if (balance) {
          const booked = this.balanceUnits
          const cost = choice ? catalog[choice.variantId].costUnits : 0
          const valid = this.dataset.authenticated === 'true' && Number.isSafeInteger(booked) && booked >= 0 && booked % 100 === 0
          const preview = valid && choice && cartConfirmed && !failed && !writing && Number.isSafeInteger(cost) && cost > 0 && cost % 100 === 0 && cost <= booked
          const available = preview ? booked - cost : booked
          balance.hidden = !valid
          const unknown = this.querySelector('[data-reward-balance-unknown]')
          if (unknown) unknown.hidden = valid
          const bookedText = balance.querySelector('[data-reward-booked]')
          if (bookedText) bookedText.textContent = valid ? String(booked / 100) : ''
          balance.querySelector('[data-reward-projection]').hidden = !preview
          balance.querySelector('[data-reward-remaining]').textContent = preview ? String(available / 100) : ''
          balance.querySelector('[data-reward-planned]').textContent = preview ? String(cost / 100) : ''
          const orange = valid ? Math.min(available / 100, 500) / 5 : 0
          const gray = valid ? Math.min(booked / 100, 500) / 5 - orange : 0
          balance.querySelector('[data-reward-bar-available]').style.width = `${orange}%`
          balance.querySelector('[data-reward-bar-planned]').style.width = `${gray}%`
          balance.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', String(valid ? Math.min(available / 100, 500) : 0))
        }
        this.setAttribute('aria-busy', String(writing > 0))
      }
    }
    customElements.define('frucare-reward-cart', FruCareRewardCart)
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.attachShadowRoots(this)
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return
      }

      element.querySelectorAll('template[shadowrootmode]').forEach((template) => {
        const mode = template.getAttribute('shadowrootmode')
        const shadowRoot = template.parentNode.attachShadow({ mode })

        shadowRoot.appendChild(template.content)
        template.remove()
        this.attachShadowRoots(shadowRoot)
      })
    }
  }

  customElements.define('layout-grid', LayoutGrid)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.attachShadowRoots(this)
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return
      }

      element.querySelectorAll('template[shadowrootmode]').forEach((template) => {
        const mode = template.getAttribute('shadowrootmode')
        const shadowRoot = template.parentNode.attachShadow({ mode })

        shadowRoot.appendChild(template.content)
        template.remove()
        this.attachShadowRoots(shadowRoot)
      })
    }
  }

  customElements.define('layout-stack', LayoutStack)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.sticky-scroller"] && !Shopify.designMode) return;
  try {
    class StickyScroller extends HTMLElement {
    constructor() {
      super()
      this.resizeObserver = new ResizeObserver(() => this.recalculateStyles())
      this.abortController = new AbortController()
      this.isScrolling = false
      this.position = 'relative'
      this.lastKnownScrollY = 0
      this.initialTop = 0
      this.currentTop = 0
      this.boundOnScroll = this.onScroll.bind(this)
    }

    connectedCallback() {
      this.inView(this, this.setupObservers.bind(this), { margin: '500px' })
    }

    disconnectedCallback() {
      this.cleanupObservers()
    }

    setupObservers() {
      this.resizeObserver.observe(this)
      window.addEventListener('scroll', this.boundOnScroll, { passive: true, signal: this.abortController.signal })
      return this.cleanupObservers.bind(this)
    }

    cleanupObservers() {
      this.abortController.abort()
      this.resizeObserver.disconnect()
    }

    onScroll() {
      if (!this.isScrolling) {
        requestAnimationFrame(() => {
          this.updatePosition()
          this.isScrolling = false
        })
        this.isScrolling = true
      }
    }

    recalculateStyles() {
      this.style.removeProperty('top')
      const { top, position } = getComputedStyle(this)
      this.initialTop = parseInt(top, 10)
      this.position = position
      this.updatePosition()
    }

    updatePosition() {
      if (this.position !== 'sticky') {
        this.style.removeProperty('top')
        return
      }

      const { top, height } = this.getBoundingClientRect()
      const maxTop = top + window.scrollY - this.offsetTop + this.initialTop
      const minTop = height - window.innerHeight + 20

      this.currentTop += this.lastKnownScrollY - window.scrollY
      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTop)

      this.lastKnownScrollY = window.scrollY
      this.style.top = `${Math.round(this.currentTop)}px`
    }

    /**
     * Original source from https://www.npmjs.com/package/@motionone/dom
     * Usage: https://motion.dev/dom/in-view
     */
    inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = 'any' } = {}) {
      const thresholds = {
        any: 0,
        all: 1
      }

      if (typeof IntersectionObserver === 'undefined') {
        return () => {}
      }

      let elements
      if (typeof elementOrSelector === 'string') {
        elements = document.querySelectorAll(elementOrSelector)
      } else if (elementOrSelector instanceof Element) {
        elements = [elementOrSelector]
      } else {
        elements = Array.from(elementOrSelector || [])
      }

      const activeIntersections = new WeakMap()
      const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
          const onEnd = activeIntersections.get(entry.target)
          if (entry.isIntersecting === Boolean(onEnd)) return
          if (entry.isIntersecting) {
            const newOnEnd = onStart(entry)
            if (typeof newOnEnd === 'function') {
              activeIntersections.set(entry.target, newOnEnd)
            } else {
              observer.unobserve(entry.target)
            }
          } else if (onEnd) {
            onEnd(entry)
            activeIntersections.delete(entry.target)
          }
        })
      }

      const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === 'number' ? amount : thresholds[amount]
      })

      elements.forEach((element) => observer.observe(element))
      return () => observer.disconnect()
    }
  }

  customElements.define('sticky-scroller', StickyScroller)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.drawer"] && !Shopify.designMode) return;
  try {
    function animateWithClass(element, className) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return Promise.resolve()
    }

    return new Promise((resolve) => {
      function handleAnimationEnd(event) {
        if (event.target === element) {
          element.removeEventListener('animationend', handleAnimationEnd)
          element.classList.remove(className)
          resolve()
        }
      }
      element.addEventListener('animationend', handleAnimationEnd)
      element.classList.add(className)
    })
  }

  class OverlayDrawer extends HTMLElement {
    #dialog = null
    #originalTrigger = null
    #abortController = null

    connectedCallback() {
      this.#dialog = this.querySelector('dialog')
      if (!this.#dialog) return

      this.#abortController = new AbortController()
      const { signal } = this.#abortController

      this.#dialog.addEventListener('cancel', (e) => this.#handleCancel(e), { signal })
      this.#dialog.addEventListener('click', (e) => this.#handleClick(e), { signal })
      this.#dialog.addEventListener('pointerdown', (e) => this.#handlePointerDown(e), { signal })
    }

    disconnectedCallback() {
      this.#abortController?.abort()
    }

    get lightDismiss() {
      return this.getAttribute('light-dismiss') !== 'false'
    }

    async show() {
      if (this.#dialog.open) return

      const showEvent = new CustomEvent('drawer:show', {
        bubbles: true,
        cancelable: true
      })
      this.dispatchEvent(showEvent)
      if (showEvent.defaultPrevented) return

      this.#originalTrigger = document.activeElement
      this.#dialog.showModal()

      await animateWithClass(this.#dialog, 'overlay-drawer--show')

      requestAnimationFrame(() => {
        // Only set focus if nothing inside the dialog is already focused
        if (!this.#dialog.contains(document.activeElement)) {
          const elementToFocus = this.#dialog.querySelector('[autofocus]')
          elementToFocus?.focus() ?? this.#dialog.focus()
        }
      })

      this.dispatchEvent(new CustomEvent('drawer:after-show', { bubbles: true }))
    }

    async hide(source = this) {
      if (!this.#dialog.open) return

      const hideEvent = new CustomEvent('drawer:hide', {
        bubbles: true,
        cancelable: true,
        detail: { source }
      })
      this.dispatchEvent(hideEvent)

      if (hideEvent.defaultPrevented) {
        await animateWithClass(this.#dialog, 'overlay-drawer--pulse')
        return
      }

      await animateWithClass(this.#dialog, 'overlay-drawer--hide')
      this.#dialog.close()

      if (this.#originalTrigger?.focus) {
        setTimeout(() => {
          try {
            this.#originalTrigger.focus({ preventScroll: true })
          } catch {
            this.#originalTrigger.focus()
          }
        }, 0)
      }

      this.dispatchEvent(new CustomEvent('drawer:after-hide', { bubbles: true }))
    }

    #handleCancel(event) {
      event.preventDefault()
      this.hide(this)
    }

    #handleClick(event) {
      const closeButton = event.target.closest('[data-drawer="close"]')
      if (closeButton) {
        event.stopPropagation()
        this.hide(closeButton)
      }
    }

    async #handlePointerDown(event) {
      if (event.target !== this.#dialog) return

      const rect = this.#dialog.getBoundingClientRect()
      const isClickInsideDialog =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom

      if (!isClickInsideDialog) {
        if (this.lightDismiss) {
          this.hide(this)
        } else {
          await animateWithClass(this.#dialog, 'overlay-drawer--pulse')
        }
      }
    }
  }

  customElements.define('overlay-drawer', OverlayDrawer)

  // Global trigger handler
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-drawer]')
    if (!trigger) return

    const attr = trigger.getAttribute('data-drawer')
    if (!attr) return

    const [command, id] = attr.trim().split(/\s+/)

    if (command === 'open' && id) {
      const drawer = document.getElementById(id)
      if (drawer?.tagName === 'OVERLAY-DRAWER') {
        event.preventDefault()
        drawer.show()
      }
    }
  })

  // Safari fix for backdrop clicks
  document.body.addEventListener('pointerdown', () => {})
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.lightbox"] && !Shopify.designMode) return;
  try {
    class OverlayLightbox extends HTMLElement {
    // Static registry to track all lightbox instances
    static registry = new Map()
    // Track which groups have been prefetched
    static prefetchedGroups = new Set()

    constructor() {
      super()
      this.trigger = null
      this.template = null
      this.overlay = null
      this.closeBtn = null
      this.prevBtn = null
      this.nextBtn = null
      this.group = this.dataset.group
      this.groupItems = []
      this.currentIndex = 0

      // Register this instance
      if (this.group) {
        if (!OverlayLightbox.registry.has(this.group)) {
          OverlayLightbox.registry.set(this.group, [])
        }
        OverlayLightbox.registry.get(this.group).push(this)
      }
    }

    connectedCallback() {
      // Initialize elements when connected to DOM
      this.trigger = this.querySelector('.overlay-lightbox__trigger')
      this.template = this.querySelector('.overlay-lightbox__template')
      this.init()
    }

    init() {
      // Open lightbox on trigger click
      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault()
          this.openLightbox()
        })
      }

      // Handle ESC key globally
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.closeLightbox()
        } else if (this.isOpen() && this.group) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault()
            this.navigateToPrevious()
          } else if (e.key === 'ArrowRight') {
            e.preventDefault()
            this.navigateToNext()
          }
        }
      })
    }

    openLightbox() {
      // Create overlay if it doesn't exist
      if (!this.overlay) {
        this.createOverlay()
      }

      this.overlay.classList.add('overlay-lightbox__overlay--open')
      document.body.style.overflow = 'hidden'

      // If this is part of a group, find all group items
      if (this.group) {
        this.findGroupItems()

        // Prefetch images for the group
        this.prefetchGroupImages()

        // Add single-item class if there's only one item in the group
        if (this.groupItems.length <= 1) {
          this.overlay.classList.add('overlay-lightbox__overlay--single-item')
        } else {
          this.overlay.classList.remove('overlay-lightbox__overlay--single-item')
        }
      } else {
        // No group, so hide navigation buttons
        this.overlay.classList.add('overlay-lightbox__overlay--single-item')
      }
    }

    createOverlay() {
      // Check if template exists
      if (!this.template) {
        console.error('OverlayLightbox: Template not found')
        return
      }

      // Clone the template content
      this.overlay = this.template.content.cloneNode(true).querySelector('.overlay-lightbox__overlay')

      // Check if overlay was created successfully
      if (!this.overlay) {
        console.error('OverlayLightbox: Overlay element not found in template')
        return
      }

      // Get references to buttons
      this.closeBtn = this.overlay.querySelector('.lightbox-close')
      this.prevBtn = this.overlay.querySelector('.overlay-lightbox__nav--prev')
      this.nextBtn = this.overlay.querySelector('.overlay-lightbox__nav--next')

      // Add event listeners
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault()
          this.closeLightbox()
        })
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault()
          this.navigateToPrevious()
        })
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault()
          this.navigateToNext()
        })
      }

      // Close lightbox when clicking outside content
      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) {
            this.closeLightbox()
          }
        })
      }

      // Append to body
      if (this.overlay) {
        document.body.appendChild(this.overlay)
      }
    }

    closeLightbox() {
      if (this.overlay) {
        this.overlay.classList.remove('overlay-lightbox__overlay--open')
        this.overlay.classList.remove('overlay-lightbox__overlay--single-item')

        // Remove overlay immediately
        if (this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay)
          this.overlay = null
          this.closeBtn = null
          this.prevBtn = null
          this.nextBtn = null
        }
      }

      document.body.style.overflow = ''
    }

    findGroupItems() {
      // Use the static registry to find group items
      this.groupItems = OverlayLightbox.registry.get(this.group) || []
      this.currentIndex = this.groupItems.indexOf(this)
    }

    navigateToPrevious() {
      if (!this.group || this.groupItems.length <= 1) return

      let targetIndex = this.currentIndex - 1
      if (targetIndex < 0) {
        // Loop to last item
        targetIndex = this.groupItems.length - 1
      }

      const targetLightbox = this.groupItems[targetIndex]
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox)
      }
    }

    navigateToNext() {
      if (!this.group || this.groupItems.length <= 1) return

      let targetIndex = this.currentIndex + 1
      if (targetIndex >= this.groupItems.length) {
        // Loop to first item
        targetIndex = 0
      }

      const targetLightbox = this.groupItems[targetIndex]
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox)
      }
    }

    switchToLightbox(targetLightbox) {
      // Close current lightbox
      this.closeLightbox()

      // Open target lightbox immediately
      targetLightbox.openLightbox()
    }

    prefetchGroupImages() {
      // Only prefetch once per group
      if (this.group && !OverlayLightbox.prefetchedGroups.has(this.group)) {
        OverlayLightbox.prefetchedGroups.add(this.group)

        this.groupItems.forEach((lightbox) => {
          // Find all images in this lightbox's content
          const images = lightbox.querySelectorAll('img')
          images.forEach((img) => {
            // Prefetch the largest available image
            this.prefetchLargestImage(img)
          })
        })
      }
    }

    prefetchLargestImage(img) {
      // Try to get the largest image from srcset first
      if (img.srcset) {
        const srcsetUrls = img.srcset.split(',').map((src) => src.trim().split(' ')[0])
        // Find the largest size (highest number in the URL)
        let largestUrl = img.src
        let largestSize = 0

        srcsetUrls.forEach((url) => {
          const size = this.extractImageSize(url)
          if (size > largestSize) {
            largestSize = size
            largestUrl = url
          }
        })

        this.prefetchImage(largestUrl)
      } else {
        // No srcset, try to get largest size from original URL
        const largestUrl = this.getLargestImageUrl(img.src)
        this.prefetchImage(largestUrl)
      }
    }

    extractImageSize(url) {
      try {
        const urlObj = new URL(url)

        // Check for width parameter
        if (urlObj.searchParams.has('width')) {
          return parseInt(urlObj.searchParams.get('width')) || 0
        }

        // Check for underscore format (image_2400x.jpg)
        const pathParts = urlObj.pathname.split('_')
        if (pathParts.length > 1) {
          const sizeMatch = pathParts[pathParts.length - 1].match(/(\d+)x/)
          if (sizeMatch) {
            return parseInt(sizeMatch[1]) || 0
          }
        }
      } catch (e) {
        // URL parsing failed
      }

      return 0
    }

    getLargestImageUrl(originalUrl) {
      try {
        const url = new URL(originalUrl)

        // Handle Shopify image URLs - try to get 2400px version
        if (url.searchParams.has('width')) {
          url.searchParams.set('width', '2400')
          return url.toString()
        } else if (url.pathname.includes('_')) {
          // Handle Shopify's underscore format
          const pathParts = url.pathname.split('_')
          if (pathParts.length > 1) {
            const extension = pathParts[pathParts.length - 1].split('.')[1] || 'jpg'
            const newPath = pathParts.slice(0, -1).join('_') + '_2400x.' + extension
            url.pathname = newPath
            return url.toString()
          }
        }
      } catch (e) {
        // If URL parsing fails, return original
      }

      return originalUrl
    }

    prefetchImage(url) {
      const prefetchImg = new Image()
      prefetchImg.src = url
    }

    isOpen() {
      return this.overlay && this.overlay.classList.contains('overlay-lightbox__overlay--open')
    }

    // Clean up when element is removed
    disconnectedCallback() {
      if (this.group) {
        const groupItems = OverlayLightbox.registry.get(this.group)
        if (groupItems) {
          const index = groupItems.indexOf(this)
          if (index > -1) {
            groupItems.splice(index, 1)
          }
          // Remove empty groups
          if (groupItems.length === 0) {
            OverlayLightbox.registry.delete(this.group)
          }
        }
      }
    }
  }

  // Define the custom element
  customElements.define('overlay-lightbox', OverlayLightbox)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    class ProductHotReload extends HTMLElement {
    constructor() {
      super()
      this.cache = new Map() // Cache for pre-fetched content
      this.activeRequests = new Map() // Track active fetch requests
      this.loadingTimeout = null // Timeout for loading state
      this.supportsViewTransitions = 'startViewTransition' in document

      this.addEventListener('change', (event) => this.onVariantChange(event))
      this.addEventListener('mouseover', (event) => this.onMouseOver(event))
    }

    showLoadingState() {
      // Start loading state (pulse) after 200ms
      this.loadingTimeout = setTimeout(() => {
        this.classList.add('product-hot-reload--loading')
      }, 200)
    }

    hideLoadingState() {
      // Clear the timeout if it hasn't triggered yet
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout)
        this.loadingTimeout = null
      }

      // Remove loading animation
      this.classList.remove('product-hot-reload--loading')
    }

    buildRequestUrl(input) {
      const productFormElement = input.closest('form')
      const sectionId = this.dataset.sectionId

      // Get dataset values from the input or selected option
      let newProductUrl, optionValueId

      if (input.type === 'radio') {
        newProductUrl = input.dataset.productUrl
        optionValueId = input.dataset.optionValueId
      } else if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex]
        newProductUrl = selectedOption.dataset.productUrl
        optionValueId = selectedOption.dataset.optionValueId
      }

      // Get all currently selected values from both radio inputs and select elements
      let selectedOptionValues = []

      // Get values from checked radio inputs
      const checkedRadios = Array.from(productFormElement.querySelectorAll('input[type="radio"]:checked'))
      selectedOptionValues = checkedRadios.map(({ dataset }) => dataset.optionValueId).filter(Boolean)

      // Get values from select elements
      const selects = Array.from(productFormElement.querySelectorAll('select'))
      selects.forEach((select) => {
        const selectedOption = select.options[select.selectedIndex]
        if (selectedOption && selectedOption.dataset.optionValueId) {
          selectedOptionValues.push(selectedOption.dataset.optionValueId)
        }
      })

      // If we're building for a hover state, replace the current option's value
      if (input.type === 'radio' && !input.checked) {
        const currentOptionName = input.name
        // Remove any existing selection for this option
        selectedOptionValues = selectedOptionValues.filter((id) => {
          const input = productFormElement.querySelector(`input[data-option-value-id="${id}"]`)
          return input && input.name !== currentOptionName
        })
        // Add the hovered option value
        selectedOptionValues.push(optionValueId)
      }

      const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : ''
      return `${newProductUrl}?section_id=${sectionId}${params}`
    }

    onMouseOver(event) {
      const label = event.target.closest('label')
      if (!label) return

      const input = label.querySelector('input[type="radio"]')
      if (!input) return

      // Don't pre-fetch if already selected
      if (input.checked) return

      const requestUrl = this.buildRequestUrl(input)

      // Don't prefetch if we already have cached content or an active request
      if (this.cache.has(requestUrl) || this.activeRequests.has(requestUrl)) return

      // Pre-fetch the content for this option
      this.fetchContent(requestUrl)
    }

    fetchContent(requestUrl) {
      // Create and store the fetch promise
      const fetchPromise = fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          this.cache.set(requestUrl, html)
          this.activeRequests.delete(requestUrl)
          return html
        })
        .catch((error) => {
          this.activeRequests.delete(requestUrl)
          throw error
        })

      this.activeRequests.set(requestUrl, fetchPromise)
      return fetchPromise
    }

    async onVariantChange(event) {
      if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return

      const optionValueElement = event.target
      const requestUrl = this.buildRequestUrl(optionValueElement)
      const oldProductUrl = this.dataset.productUrl

      // Get new product URL from the input or selected option
      let newProductUrl
      if (optionValueElement.type === 'radio') {
        newProductUrl = optionValueElement.dataset.productUrl || oldProductUrl
      } else if (optionValueElement.tagName === 'SELECT') {
        const selectedOption = optionValueElement.options[optionValueElement.selectedIndex]
        newProductUrl = selectedOption.dataset.productUrl || oldProductUrl
      } else {
        newProductUrl = oldProductUrl
      }

      // Start loading state immediately on change event
      this.showLoadingState()

      let html

      try {
        // Use cached content if available
        if (this.cache.has(requestUrl)) {
          html = this.cache.get(requestUrl)
        }
        // Wait for active request if one exists
        else if (this.activeRequests.has(requestUrl)) {
          html = await this.activeRequests.get(requestUrl)
        }
        // Make new request if no cache or active request
        else {
          html = await this.fetchContent(requestUrl)
        }

        await this.updateProductWithTransition(html, newProductUrl, event.target.id)
      } catch (error) {
        console.error('Error updating product content:', error)
      } finally {
        // Always hide loading state
        this.hideLoadingState()
      }
    }

    async updateProductWithTransition(html, newProductUrl, targetId) {
      const updatedHtml = html.getElementById(this.id)

      if (this.supportsViewTransitions) {
        // Use View Transitions API for smooth transitions
        const transition = document.startViewTransition(() => {
          this.innerHTML = updatedHtml.innerHTML
          this.dataset.productUrl = updatedHtml.dataset.productUrl
          this.dataset.variantId = updatedHtml.dataset.variantId
        })

        // Wait for the transition to complete
        await transition.finished
      } else {
        // Fallback: Update content immediately without animations
        this.innerHTML = updatedHtml.innerHTML
        this.dataset.productUrl = updatedHtml.dataset.productUrl
        this.dataset.variantId = updatedHtml.dataset.variantId
      }

      // Update URL and history
      let url = new URL(newProductUrl, window.location.origin)

      // Preserve all existing URL parameters from the current page
      const currentUrl = new URL(window.location.href)
      for (const [key, value] of currentUrl.searchParams.entries()) {
        // Don't override the variant parameter we're setting
        if (key !== 'variant') {
          url.searchParams.set(key, value)
        }
      }

      // Add variant param if variantId exists
      url.searchParams.set('variant', this.dataset.variantId)

      // Push new state to browser history
      window.history.pushState({}, '', url.toString())

      // Focus the input for the last clicked option value
      this.querySelector(`#${targetId}`).focus()
    }
  }

  customElements.define('product-hot-reload', ProductHotReload)
  } catch(e) { console.error(e); }
})();

})();
